import React, { Component } from 'react';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import Breadcrumb from '../../Layouts/Breadcrumb';
import AuthApi from '../../Services/Authapi';
import AuthCheckComponent from '../../Layouts/Token';
import ls from 'local-storage';
import swal from 'sweetalert';
import { createSwalLoaderNode } from '../../Layouts/swalLoader';
import moment from 'moment';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  CircularProgress,
  Tooltip,
  Card,
  Typography,
  InputAdornment,
  Popover,
  Box,
  Divider,
  ListItemText,
  Avatar,
  Checkbox,
  Grid,
  IconButton,
  Menu,
  Chip
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import SettingsIcon from '@material-ui/icons/Settings';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import AssignmentIcon from '@material-ui/icons/Assignment';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import PersonIcon from '@material-ui/icons/Person';
import SendIcon from '@material-ui/icons/Send';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CheckIcon from '@material-ui/icons/Check';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import ImageIcon from '@material-ui/icons/Image';
import HistoryIcon from '@material-ui/icons/History';
import GetAppIcon from '@material-ui/icons/GetApp';
import VisibilityIcon from '@material-ui/icons/Visibility';
import FontAwesomeIconComponent from '../../Layouts/FontAwesomeIconComponent';

import DdMmYyyyDateField from '../../../utils/DdMmYyyyDateField';
import WysiwygDescriptionEditor from './WysiwygDescriptionEditor';
import FilePreviewDialog, { downloadFileDirect } from './FilePreviewDialog';
import { clampAndFormatTimeline, validateTimeline, parseTimelineHoursMinutes, TimelineSegmentedCell } from './TimelineInputField';
import './TaskManagement.css';
import '../Leaves/Leave.css';
import TableComponent from '../../Layouts/TableComponent';

// Kanban Columns mapping to DB statuses (4 standard columns on board)
const STATUS_COLUMNS = [
  { id: 'Pending', label: 'To Do', color: '#0284c7', dot: '#38bdf8' },
  { id: 'In Progress', label: 'In Progress', color: '#f59e0b', dot: '#fbbf24' },
  { id: 'In Discuss', label: 'In Discuss', color: '#0ea5e9', dot: '#38bdf8' },
  { id: 'Done', label: 'Done', color: '#10b981', dot: '#34d399' }
];

const ALL_STATUS_COLUMNS = [
  { id: 'Backlog', label: 'Backlog', color: '#475569', dot: '#94a3b8' },
  ...STATUS_COLUMNS
];

const TASK_TABLE_HEADERS = [
  { id: 'select', numeric: false, disablePadding: true, label: '', sortable: false, style: { width: '50px', minWidth: '50px', textAlign: 'center' } },
  { id: 'project_task_id', numeric: false, disablePadding: false, label: 'Task ID', sortable: true, style: { width: '115px', minWidth: '100px', maxWidth: '130px', textAlign: 'center' } },
  { id: 'priority', numeric: false, disablePadding: false, label: 'Priority', sortable: true, style: { width: '120px', minWidth: '120px', maxWidth: '120px', textAlign: 'center' } },
  { id: 'task', numeric: false, disablePadding: false, label: 'Task', sortable: true, style: { minWidth: '150px' } },
  { id: 'project_name', numeric: false, disablePadding: false, label: 'Project Name', sortable: true, style: { minWidth: '130px', textAlign: 'left' } },
  { id: 'assigned_developer', numeric: false, disablePadding: false, label: 'Assign Developer', sortable: false, style: { minWidth: '160px', whiteSpace: 'nowrap' } },
  { id: 'task_deliver_date', numeric: false, disablePadding: false, label: 'Deliver Date', sortable: true, style: { minWidth: '110px', whiteSpace: 'nowrap' } },
  { id: 'timeline', numeric: false, disablePadding: false, label: 'Timeline', sortable: true, style: { width: '120px', minWidth: '110px', maxWidth: '135px', textAlign: 'center' } },
  { id: 'status', numeric: false, disablePadding: false, label: 'Status', sortable: true, style: { width: '130px', minWidth: '130px', maxWidth: '130px', textAlign: 'center' } },
  { id: 'actions', numeric: false, disablePadding: false, label: 'Actions', sortable: false, style: { minWidth: '110px', width: '110px', textAlign: 'center' } }
];

class TaskManagement extends Component {
  constructor(props) {
    super(props);
    this.drawerFileInputRef = React.createRef();
    const savedView = ls.get('task_current_view');

    // Instant-load cache check from sessionStorage (Stale-While-Revalidate pattern)
    let cachedTasks = [];
    let cachedProjects = [];
    let cachedUsers = [];
    let hasCache = false;
    try {
      const rawTasks = typeof window !== 'undefined' ? window.sessionStorage.getItem('ems_cached_tasks') : null;
      const rawProjects = typeof window !== 'undefined' ? window.sessionStorage.getItem('ems_cached_projects') : null;
      const rawUsers = typeof window !== 'undefined' ? window.sessionStorage.getItem('ems_cached_users') : null;
      if (rawTasks) cachedTasks = JSON.parse(rawTasks) || [];
      if (rawProjects) cachedProjects = JSON.parse(rawProjects) || [];
      if (rawUsers) cachedUsers = JSON.parse(rawUsers) || [];
      if (Array.isArray(cachedTasks) && cachedTasks.length > 0) hasCache = true;
    } catch (_) {}

    this.state = {
      projects: cachedProjects,
      selectedProject: 'ALL', // 'ALL' or specific project_name
      allUsers: cachedUsers,
      activeUsers: cachedUsers.filter(u => Number(u.user_logged) === 1),
      userPopoverAnchor: null,
      userSearchQuery: '',
      tasks: cachedTasks,
      loading: !hasCache,
      currentView: (savedView === 'list' || savedView === 'board') ? savedView : 'board', // 'board' or 'list'
      searchQuery: '',
      filterOnlyMyTasks: false,
      filterPriority: 'all',
      filterAssigneeId: 'all',
      filterStatus: 'all',
      priorityMenuAnchor: null,
      priorityMenuTaskId: null,
      statusMenuAnchor: null,
      statusMenuTaskId: null,
      timelineDrafts: {},

      // Drawer state (Task Detail View)
      activeDrawerTask: null,
      drawerActivity: [],
      drawerLoadingActivity: false,
      drawerNewComment: '',
      drawerNewSubtaskTitle: '',
      drawerActiveTab: 'activity', // 'activity' or 'details'
      drawerEditingSubtaskIdx: null,
      drawerEditingSubtaskName: '',
      drawerActivityOpen: false,
      drawerDescEditing: false,
      drawerTaskNameEditing: false,
      drawerTaskNameError: '',
      drawerUploadingFile: false,
      previewFile: null,

      // Quick Create Modal state
      isCreateModalOpen: false,
      createTaskSubmitting: false,
      createTaskForm: {
        task: '',
        project_name: '',
        developer_user_id: '',
        developer_name: '',
        status: 'Pending',
        priority: 'Medium',
        task_date_time: this.getCurrentDateTimeString(),
        task_deliver_date: this.getDefaultDeliverDateString(),
        description: '',
        subTasks: []
      },
      newSubtaskInput: '',

      // Quick Add Project Modal state
      isAddProjectModalOpen: false,
      addProjectSubmitting: false,
      addProjectForm: {
        project_name: '',
        description: '',
        start_date: '',
        target_date: '',
        member_ids: []
      },
      addProjectFiles: [],
      addProjectMilestones: [],
      newMilestoneInput: '',
      projectUserPopoverAnchor: null,
      projectUserSearchQuery: '',

      // Manage Projects & Edit Project modal state
      manageProjectsOpen: false,
      manageProjectsSearch: '',
      editProjectDialogOpen: false,
      editProjectLoading: false,
      editingProject: {
        id: null,
        project_name: '',
        start_date: '',
        target_date: '',
        member_ids: [],
        description: '',
      },
      editProjectErrors: {},
      editProjectUserPopoverAnchor: null,
      editProjectUserSearch: ''
    };
  }

  getCurrentDateTimeString() {
    const now = new Date();
    const pad = (n) => String(n).padStart(2, '0');
    return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:00`;
  }

  getDefaultDeliverDateString() {
    const future = new Date(Date.now() + 3 * 24 * 60 * 60 * 1000);
    const pad = (n) => String(n).padStart(2, '0');
    return `${future.getFullYear()}-${pad(future.getMonth() + 1)}-${pad(future.getDate())} 18:00:00`;
  }

  formatDateForDisplay(dateStr) {
    if (!dateStr || String(dateStr).trim() === '' || String(dateStr).startsWith('0000-00-00')) return '';
    try {
      if (typeof moment !== 'undefined') {
        const m = moment(dateStr, [
          'YYYY-MM-DD HH:mm:ss',
          'YYYY-MM-DD HH:mm',
          'DD-MM-YYYY HH:mm:ss',
          'DD-MM-YYYY hh:mm A',
          'DD-MM-YYYY',
          'YYYY-MM-DD'
        ]);
        if (m.isValid()) {
          return m.format('DD MMM YYYY, hh:mm A');
        }
      }
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) {
        return dateStr;
      }
      const day = String(d.getDate()).padStart(2, '0');
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const month = monthNames[d.getMonth()];
      const year = d.getFullYear();
      let hours = d.getHours();
      const minutes = String(d.getMinutes()).padStart(2, '0');
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12;
      return `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`;
    } catch (_) {
      return dateStr;
    }
  }

  formatTime12(d) {
    let hours = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    const hStr = String(hours).padStart(2, '0');
    return `${hStr}:${minutes} ${ampm}`;
  }

  getCardDueDateInfo(task) {
    if (!task) return null;
    const deliverDate = task.task_deliver_date;
    const startDateTime = task.task_date_time;

    // Both absent -> render nothing
    if (!deliverDate && !startDateTime) return null;

    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    // 1. Deliver Date (Due Date) is prioritized if present
    if (deliverDate) {
      const d = new Date(String(deliverDate).replace(' ', 'T'));
      if (!isNaN(d.getTime())) {
        const targetDay = new Date(d.getFullYear(), d.getMonth(), d.getDate());
        const diffDays = Math.ceil((targetDay - today) / (1000 * 60 * 60 * 24));
        const hasTime = d.getHours() !== 0 || d.getMinutes() !== 0;
        const timeStr = hasTime ? this.formatTime12(d) : '';
        const dateText = `${d.getDate()} ${monthNames[d.getMonth()]}`;

        if (diffDays < 0) {
          return {
            text: dateText,
            status: 'overdue',
            label: `Due: ${dateText}${timeStr ? ', ' + timeStr : ''}`
          };
        } else if (diffDays === 0) {
          return {
            text: timeStr ? `Today, ${timeStr}` : 'Today',
            status: 'today',
            label: `Due Today${timeStr ? ' at ' + timeStr : ''}`
          };
        } else if (diffDays === 1) {
          return {
            text: timeStr ? `Tomorrow, ${timeStr}` : 'Tomorrow',
            status: 'tomorrow',
            label: `Due Tomorrow${timeStr ? ' at ' + timeStr : ''}`
          };
        } else {
          return {
            text: `${dateText}${timeStr ? ', ' + timeStr : ''}`,
            status: 'normal',
            label: `Due Date: ${dateText}${timeStr ? ', ' + timeStr : ''}`
          };
        }
      }
    }

    // 2. Fallback to Set Time (task_date_time) if Due Date is not set
    if (startDateTime) {
      const raw = String(startDateTime).trim();
      if (/^\d{1,2}:\d{2}/.test(raw) && !raw.includes('-')) {
        return { text: raw, status: 'normal', label: `Set Time: ${raw}` };
      }

      const d = new Date(raw.replace(' ', 'T'));
      if (!isNaN(d.getTime())) {
        const targetDay = new Date(d.getFullYear(), d.getMonth(), d.getDate());
        const diffDays = Math.ceil((targetDay - today) / (1000 * 60 * 60 * 24));
        const hasTime = d.getHours() !== 0 || d.getMinutes() !== 0;
        const timeStr = hasTime ? this.formatTime12(d) : '';
        const dateText = `${d.getDate()} ${monthNames[d.getMonth()]}`;

        if (diffDays === 0) {
          return {
            text: timeStr || 'Today',
            status: 'normal',
            label: `Set Time: ${timeStr || dateText}`
          };
        } else {
          return {
            text: `${dateText}${timeStr ? ', ' + timeStr : ''}`,
            status: 'normal',
            label: `Set Time: ${dateText}${timeStr ? ', ' + timeStr : ''}`
          };
        }
      }
    }

    return null;
  }

  getInitials(name) {
    if (!name) return 'U';
    const parts = name.trim().split(' ');
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }

  getAssignedUsersForTask = (task) => {
    if (!task) return [];
    const { allUsers, activeUsers } = this.state;
    const matchedUsers = [];
    const matchedIds = new Set();
    const matchedNames = new Set();

    // Prefer active users pool (user_logged === 1) so inactive/deactivated users are not counted
    const userPool = (activeUsers && activeUsers.length > 0)
      ? activeUsers
      : (allUsers && allUsers.length > 0 ? allUsers.filter((u) => Number(u.user_logged) === 1) : []);
    const fallbackPool = (allUsers && allUsers.length > 0) ? allUsers : userPool;

    // 1. If task has explicit member_ids or developer_user_ids
    const rawIds = task.member_ids || task.developer_user_ids || [];
    const extractedIds = this.extractIds(rawIds);
    if (extractedIds.length > 0) {
      extractedIds.forEach((id) => {
        const u = userPool.find((user) => Number(user.id) === Number(id));
        if (u && !matchedIds.has(Number(u.id))) {
          matchedUsers.push(u);
          matchedIds.add(Number(u.id));
          const fn = `${u.firstName || ''} ${u.lastName || ''}`.trim().toLowerCase();
          if (fn) matchedNames.add(fn);
          if (u.name) matchedNames.add(u.name.trim().toLowerCase());
          if (u.firstName) matchedNames.add(u.firstName.trim().toLowerCase());
        }
      });
      if (matchedUsers.length > 0) {
        return matchedUsers;
      }
    }

    // 2. By primary developer_user_id (the selected assigned user)
    if (task.developer_user_id) {
      const primaryId = Number(task.developer_user_id);
      if (!matchedIds.has(primaryId)) {
        const u = userPool.find((user) => Number(user.id) === primaryId);
        if (u) {
          matchedUsers.push(u);
          matchedIds.add(primaryId);
          const fn = `${u.firstName || ''} ${u.lastName || ''}`.trim().toLowerCase();
          if (fn) matchedNames.add(fn);
          if (u.name) matchedNames.add(u.name.trim().toLowerCase());
          if (u.firstName) matchedNames.add(u.firstName.trim().toLowerCase());
        }
      }
    }

    // 3. By developer_name (which can be comma-separated names of assigned developers)
    if (task.developer_name && typeof task.developer_name === 'string') {
      const names = task.developer_name.split(',').map((n) => n.trim()).filter(Boolean);
      names.forEach((nameStr) => {
        const lower = nameStr.toLowerCase();

        // If this developer is already matched, skip to avoid duplicate user entries
        if (matchedNames.has(lower)) {
          return;
        }
        const alreadyMatched = matchedUsers.some((u) => {
          const fn = `${u.firstName || ''} ${u.lastName || ''}`.trim().toLowerCase();
          const alt = (u.name || '').trim().toLowerCase();
          const firstOnly = (u.firstName || '').trim().toLowerCase();
          return fn === lower || alt === lower || firstOnly === lower;
        });
        if (alreadyMatched) {
          return;
        }

        // Match from active user pool
        const u = userPool.find((user) => {
          if (matchedIds.has(Number(user.id))) return false;
          const fullName = `${user.firstName || ''} ${user.lastName || ''}`.trim().toLowerCase();
          const altName = (user.name || '').trim().toLowerCase();
          const first = (user.firstName || '').trim().toLowerCase();
          return fullName === lower || altName === lower || first === lower;
        });

        if (u && !matchedIds.has(Number(u.id))) {
          matchedUsers.push(u);
          matchedIds.add(Number(u.id));
          const fn = `${u.firstName || ''} ${u.lastName || ''}`.trim().toLowerCase();
          if (fn) matchedNames.add(fn);
          if (u.name) matchedNames.add(u.name.trim().toLowerCase());
          if (u.firstName) matchedNames.add(u.firstName.trim().toLowerCase());
        }
      });
    }

    // 4. Fallback for legacy tasks if no active users matched
    if (matchedUsers.length === 0 && fallbackPool.length > 0) {
      if (extractedIds.length > 0) {
        extractedIds.forEach((id) => {
          const u = fallbackPool.find((user) => Number(user.id) === Number(id));
          if (u && !matchedIds.has(Number(u.id))) {
            matchedUsers.push(u);
            matchedIds.add(Number(u.id));
          }
        });
      } else if (task.developer_user_id) {
        const u = fallbackPool.find((user) => Number(user.id) === Number(task.developer_user_id));
        if (u && !matchedIds.has(Number(u.id))) {
          matchedUsers.push(u);
          matchedIds.add(Number(u.id));
        }
      }
    }

    return matchedUsers;
  };

  renderAssigneeAvatars = (task, isCard = false) => {
    const users = this.getAssignedUsersForTask(task);
    if (!users || users.length === 0) {
      return (
        <span className="tm-history-unassigned" style={{ fontSize: '13px', fontStyle: 'italic' }}>
          Unassigned
        </span>
      );
    }

    const maxVisible = 5;
    const visibleUsers = users.slice(0, maxVisible);
    const remainingCount = users.length - maxVisible;
    const allNames = users
      .map((u) => (u.firstName ? `${u.firstName} ${u.lastName || ''}`.trim() : u.name || 'User'))
      .join(', ');

    const avatarSize = isCard ? 24 : 22;
    const fontSize = isCard ? '0.68rem' : '0.62rem';

    return (
      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {visibleUsers.map((user, idx) => {
            const displayName = user.firstName
              ? `${user.firstName} ${user.lastName || ''}`.trim()
              : user.name || 'User';
            return (
              <Tooltip key={user.id || idx} title={displayName} arrow placement="top">
                <Avatar
                  src={user.photo || ''}
                  style={{
                    width: avatarSize,
                    height: avatarSize,
                    fontSize: fontSize,
                    fontWeight: 600,
                    marginLeft: idx === 0 ? 0 : -6,
                    border: '1.5px solid #ffffff',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
                    backgroundColor: '#036dda',
                    color: '#ffffff',
                    cursor: 'pointer'
                  }}
                >
                  {this.getInitials(displayName)}
                </Avatar>
              </Tooltip>
            );
          })}

          {remainingCount > 0 && (
            <Tooltip
              title={`${users.length} user assigned (${allNames})`}
              arrow
              placement="top"
            >
              <div
                style={{
                  width: avatarSize,
                  height: avatarSize,
                  borderRadius: '50%',
                  backgroundColor: '#e2e8f0',
                  color: '#334155',
                  fontSize: isCard ? '0.62rem' : '0.60rem',
                  fontWeight: 700,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginLeft: -6,
                  border: '1.5px solid #ffffff',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
                  cursor: 'pointer'
                }}
              >
                +{remainingCount}
              </div>
            </Tooltip>
          )}
        </div>
      </div>
    );
  };

  getCurrentUserId() {
    try {
      let user = ls.get('user') || ls('user');
      if (typeof user === 'string') {
        try { user = JSON.parse(user); } catch (_) {}
      }
      if ((!user || typeof user !== 'object') && typeof window !== 'undefined') {
        const raw = window.localStorage.getItem('user');
        if (raw) {
          try { user = JSON.parse(raw); } catch (_) {}
        }
      }
      return (user && (user.id || user._id || user.user_id)) || null;
    } catch (_) {
      return null;
    }
  }

  getCurrentUserName() {
    try {
      let user = ls.get('user') || ls('user');
      if (typeof user === 'string') {
        try { user = JSON.parse(user); } catch (_) {}
      }
      return (user && (user.firstName || user.name)) || 'User';
    } catch (_) {
      return 'User';
    }
  }

  isUserSuperAdmin() {
    try {
      const roles = ls.get('roles') || ls('roles');
      if (!roles) return false;
      const adminRoles = ['super admin', 'admin', 'administrator'];
      if (typeof roles === 'string') {
        const r = roles.trim().toLowerCase();
        return adminRoles.includes(r);
      }
      if (Array.isArray(roles)) {
        return roles.some((r) => {
          const name = (typeof r === 'string' ? r : (r && r.name) || '').trim().toLowerCase();
          return adminRoles.includes(name);
        });
      }
      return false;
    } catch (_) {
      return false;
    }
  }

  handleDeleteProject = async (project) => {
    if (!project || !project.id) return;
    const pName = project.project_name || 'Project';

    // Retrieve all tasks
    let allTasks = this.state.tasks || [];
    try {
      const res = await AuthApi.getTasks();
      if (res && Array.isArray(res.data)) {
        allTasks = res.data;
      }
    } catch (_) {}

    const projectTasks = allTasks.filter((t) => {
      const tProj = String(t.project_name || '').trim().toLowerCase();
      const currName = String(project.project_name || '').trim().toLowerCase();
      const tProjId = Number(t.project_id || t.projectId || 0);
      const currId = Number(project.id || 0);
      return (tProj && currName && tProj === currName) || (tProjId && currId && tProjId === currId);
    });

    const pendingTasks = projectTasks.filter((t) => {
      const s = String(t.status || '').trim().toLowerCase();
      return s !== 'done' && s !== 'completed';
    });

    // 1. If project has pending (non-Done) tasks -> DO NOT DELETE, show warning pop up
    if (pendingTasks.length > 0) {
      swal({
        title: "Cannot Delete Project",
        text: `"${pName}" has ${pendingTasks.length} pending / ongoing task(s) (e.g. In Progress, Pending). You cannot delete a project with pending tasks. Please complete or reassign all tasks first.`,
        icon: "warning",
        dangerMode: true,
        button: "OK",
      });
      return;
    }

    // 2. If project has tasks but ALL are Done -> Do not permanently delete; offer to mark Inactive
    if (projectTasks.length > 0) {
      swal({
        title: "Cannot Delete Project",
        text: `"${pName}" has completed task history (${projectTasks.length} task(s)). Projects with work history cannot be permanently deleted. Would you like to mark this project as Inactive instead?`,
        icon: "info",
        buttons: ["Cancel", "Mark as Inactive"],
        dangerMode: true,
      }).then(async (confirm) => {
        if (confirm) {
          await this.handleSetProjectStatus(project, 0);
        }
      });
      return;
    }

    // 3. Project has 0 tasks -> Safe to permanently delete
    swal({
      title: "Delete Project?",
      text: `Are you sure you want to delete "${pName}"? There are no tasks associated with this project.`,
      icon: "warning",
      buttons: ["Cancel", "Yes, Delete"],
      dangerMode: true,
    }).then(async (confirm) => {
      if (confirm) {
        swal({
          title: "Loading",
          text: "Please wait...",
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
          content: createSwalLoaderNode()
        });

        try {
          const res = await AuthApi.deleteProject(project.id);
          if (res && (res.status === true || res.status === 200 || res.success)) {
            swal("Deleted!", "Project deleted successfully", "success");
            if (this.state.selectedProject === project.project_name) {
              this.setState({ selectedProject: "ALL" });
            }
            await this.fetchProjects();
            await this.fetchTasks();
          } else {
            swal("Error", (res && res.message) || "Failed to delete project", "error");
          }
        } catch (err) {
          console.error("Error deleting project:", err);
          swal("Error", "Something went wrong while deleting project", "error");
        }
      }
    });
  };

  handleSetProjectStatus = async (project, newStatus) => {
    if (!project || !project.id) return;
    const statusLabel = newStatus === 1 ? 'Active' : 'Inactive';
    swal({
      title: "Loading",
      text: `Marking project as ${statusLabel}...`,
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      content: createSwalLoaderNode()
    });

    try {
      const res = await AuthApi.editProject({ status: newStatus }, project.id);
      if (res && (res.status === true || res.status === 200 || res.success)) {
        swal("Updated!", `"${project.project_name}" marked as ${statusLabel}.`, "success");
        await this.fetchProjects();
      } else {
        swal("Error", (res && res.message) || "Failed to update project status", "error");
      }
    } catch (err) {
      console.error("Error updating project status:", err);
      swal("Error", "Something went wrong while updating project status", "error");
    }
  };

  handleOpenEditProject = (project) => {
    if (!project) return;
    const memberIds = this.extractIds(project.member_ids || project.members || project.developer_id);
    this.setState({
      editProjectDialogOpen: true,
      editingProject: {
        id: project.id,
        project_name: project.project_name || '',
        start_date: project.start_date || '',
        target_date: project.target_date || '',
        member_ids: memberIds,
        description: project.description || '',
      },
      editProjectErrors: {},
    });
  };

  handleSaveEditProject = async () => {
    const { editingProject } = this.state;
    if (!editingProject) return;
    const errors = {};
    if (!editingProject.project_name || !editingProject.project_name.trim()) {
      errors.project_name = "Project name is required";
    }
    if (!editingProject.member_ids || editingProject.member_ids.length === 0) {
      errors.member_ids = "Please select at least one user";
    }
    if (editingProject.start_date) {
      const m = moment(editingProject.start_date, ['YYYY-MM-DD', 'DD/MM/YYYY'], true);
      if (!m.isValid()) {
        errors.start_date = "Please enter a valid start date";
      } else if (m.year() < 1900 || m.year() > 2099) {
        errors.start_date = "Please enter a valid year (1900-2099)";
      }
    }
    if (editingProject.target_date) {
      const m = moment(editingProject.target_date, ['YYYY-MM-DD', 'DD/MM/YYYY'], true);
      if (!m.isValid()) {
        errors.target_date = "Please enter a valid end date";
      } else if (m.year() < 1900 || m.year() > 2099) {
        errors.target_date = "Please enter a valid year (1900-2099)";
      }
    }
    if (
      !errors.start_date &&
      !errors.target_date &&
      editingProject.start_date &&
      editingProject.target_date &&
      editingProject.target_date < editingProject.start_date
    ) {
      errors.target_date = "End date cannot be before start date";
    }

    if (Object.keys(errors).length > 0) {
      this.setState({ editProjectErrors: errors });
      return;
    }

    this.setState({ editProjectLoading: true });
    try {
      const memberIds = (editingProject.member_ids || []).map(Number);
      const payload = {
        project_name: editingProject.project_name.trim(),
        start_date: editingProject.start_date || null,
        target_date: editingProject.target_date || null,
        description: editingProject.description || null,
        lead_id: memberIds.length > 0 ? memberIds[0] : null,
        lead_ids: memberIds,
        member_ids: memberIds,
      };

      const res = await AuthApi.editProject(payload, editingProject.id);
      this.setState({ editProjectLoading: false });
      if (res && (res.status === true || res.status === 200 || res.success)) {
        swal("Success!", "Project updated successfully", "success");
        const oldProject = this.state.projects.find((p) => Number(p.id) === Number(editingProject.id));
        const oldName = oldProject ? oldProject.project_name : null;
        const newName = editingProject.project_name.trim();

        if (oldName && this.state.selectedProject === oldName) {
          this.setState({ selectedProject: newName });
        }

        if (oldName && newName && oldName.toLowerCase() !== newName.toLowerCase()) {
          const matchingTasks = this.state.tasks.filter(
            (t) => String(t.project_name || '').trim().toLowerCase() === oldName.trim().toLowerCase()
          );
          for (const t of matchingTasks) {
            try {
              const payload = this.buildTaskUpdatePayload(t, { project_name: newName });
              await AuthApi.updateTask(t.id, payload);
            } catch (_) {}
          }
        }

        this.setState({ editProjectDialogOpen: false });
        await this.fetchProjects();
        await this.fetchTasks();
      } else {
        swal("Error", (res && res.message) || "Failed to update project", "error");
      }
    } catch (err) {
      console.error("Error updating project:", err);
      this.setState({ editProjectLoading: false });
      swal("Error", "Something went wrong while updating project", "error");
    }
  };

  extractIds(raw) {
    if (!raw) return [];
    if (Array.isArray(raw)) {
      return raw
        .map((item) => (typeof item === 'object' && item !== null ? item.id || item.user_id : item))
        .map(Number)
        .filter((id) => !isNaN(id));
    }
    if (typeof raw === 'string') {
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          return parsed
            .map((item) => (typeof item === 'object' && item !== null ? item.id || item.user_id : item))
            .map(Number)
            .filter((id) => !isNaN(id));
        }
      } catch (_) {
        return raw.split(',').map(Number).filter((id) => !isNaN(id));
      }
    }
    if (typeof raw === 'number') {
      return [raw];
    }
    return [];
  }

  isProjectVisibleToUser(project, userId) {
    if (!project) return false;
    if (!userId) return false;
    const uid = Number(userId);

    const members = this.extractIds(project.member_ids);
    const leads = [
      ...this.extractIds(project.lead_ids),
      ...(project.lead_id ? this.extractIds(project.lead_id) : [])
    ];
    const assignedIds = [...members, ...leads];
    return assignedIds.includes(uid);
  }

  filterProjectsByPermission(projectsList) {
    const isSuperAdmin = this.isUserSuperAdmin();
    const currentUserId = this.getCurrentUserId();
    if (isSuperAdmin) {
      return projectsList;
    }
    if (!currentUserId) {
      return [];
    }
    return projectsList.filter((p) => this.isProjectVisibleToUser(p, currentUserId));
  }

  async componentDidMount() {
    await this.initData();
  }

  initData = async () => {
    // Only show center loading spinner if no tasks are cached/loaded yet
    if (!this.state.tasks || this.state.tasks.length === 0) {
      this.setState({ loading: true });
    }
    try {
      const [projectsRes, usersRes, tasksRes] = await Promise.all([
        AuthApi.getProject(),
        AuthApi.getData(),
        AuthApi.getTasks()
      ]);

      const projectsData = (projectsRes && projectsRes.data) || projectsRes || [];
      const allProjects = Array.isArray(projectsData) ? projectsData.filter(p => !p.deleted) : [];
      const projects = this.filterProjectsByPermission(allProjects);

      const usersData = (usersRes && usersRes.data) || usersRes || [];
      const allUsers = Array.isArray(usersData) ? usersData : [];
      // Only active users (user_logged === 1) appear in the Select User dropdown
      const activeUsers = allUsers.filter(u => Number(u.user_logged) === 1);

      const defaultProject = projects.length > 0 ? projects[0].project_name : '';

      let res = tasksRes;
      if (!res || (res.status === false && !Array.isArray(res.data))) {
        if (typeof AuthApi.taskslistbyuserid === 'function') {
          res = await AuthApi.taskslistbyuserid();
        }
      }

      const rawTasks = (res && res.data) || (Array.isArray(res) ? res : []);
      const historyMeta = this.getTaskHistoryMeta();
      const tasks = Array.isArray(rawTasks)
        ? rawTasks.map((t) => {
            const normalized = this.normalizeTask(t);
            const meta = historyMeta[normalized.id];
            if (meta && meta.done_date) {
              normalized.done_date = meta.done_date;
            }
            return normalized;
          })
        : [];

      // Save to cache for instant 0ms loads in future navigations
      try {
        if (typeof window !== 'undefined') {
          window.sessionStorage.setItem('ems_cached_tasks', JSON.stringify(tasks));
          window.sessionStorage.setItem('ems_cached_projects', JSON.stringify(projects));
          window.sessionStorage.setItem('ems_cached_users', JSON.stringify(allUsers));
        }
      } catch (_) {}

      this.setState(
        {
          projects,
          allUsers,
          activeUsers,
          createTaskForm: {
            ...this.state.createTaskForm,
            project_name: this.state.createTaskForm.project_name || defaultProject
          },
          tasks,
          loading: false
        },
        () => {
          // Deep linking: If URL has ?taskId=... open that task in drawer
          if (this.props.location && this.props.location.search) {
            const searchParams = new URLSearchParams(this.props.location.search);
            const targetKey = searchParams.get('taskId') || searchParams.get('task_id') || searchParams.get('id');
            if (targetKey && !this.state.activeDrawerTask) {
              const found = tasks.find(
                (t) => String(t.id) === String(targetKey) ||
                       String(t.project_task_id || '').toLowerCase() === String(targetKey).toLowerCase()
              );
              if (found) {
                this.openTaskDrawer(found);
              }
            }
          }
        }
      );
    } catch (e) {
      console.error('Error initializing task management data', e);
      this.setState({ loading: false });
    }
  };

  fetchProjects = async () => {
    try {
      const projectsRes = await AuthApi.getProject();
      const projectsData = (projectsRes && projectsRes.data) || (Array.isArray(projectsRes) ? projectsRes : []);
      const allProjects = Array.isArray(projectsData)
        ? projectsData.filter((p) => String(p.deleted) !== "1" && p.deleted !== true && p.deleted !== 1)
        : [];
      const projects = this.filterProjectsByPermission(allProjects);
      this.setState({ projects });
      return projects;
    } catch (e) {
      console.error('Error fetching projects:', e);
      return [];
    }
  };

  fetchTasks = async (silent = false) => {
    if (!silent && (!this.state.tasks || this.state.tasks.length === 0)) {
      this.setState({ loading: true });
    }
    try {
      let res = await AuthApi.getTasks();
      if (!res || (res.status === false && !Array.isArray(res.data))) {
        if (typeof AuthApi.taskslistbyuserid === 'function') {
          res = await AuthApi.taskslistbyuserid();
        }
      }

      const rawTasks = (res && res.data) || (Array.isArray(res) ? res : []);
      const historyMeta = this.getTaskHistoryMeta();
      const tasks = Array.isArray(rawTasks)
        ? rawTasks.map((t) => {
            const normalized = this.normalizeTask(t);
            const meta = historyMeta[normalized.id];
            if (meta && meta.done_date) {
              normalized.done_date = meta.done_date;
            }
            return normalized;
          })
        : [];

      try {
        if (typeof window !== 'undefined') {
          window.sessionStorage.setItem('ems_cached_tasks', JSON.stringify(tasks));
        }
      } catch (_) {}

      this.setState({
        tasks,
        loading: false
      }, () => {
        // Deep linking: If URL has ?taskId=... open that task in drawer
        if (this.props.location && this.props.location.search) {
          const searchParams = new URLSearchParams(this.props.location.search);
          const targetKey = searchParams.get('taskId') || searchParams.get('task_id') || searchParams.get('id');
          if (targetKey && !this.state.activeDrawerTask) {
            const found = tasks.find(
              (t) => String(t.id) === String(targetKey) ||
                     String(t.project_task_id || '').toLowerCase() === String(targetKey).toLowerCase()
            );
            if (found) {
              this.openTaskDrawer(found);
            }
          }
        }
      });
    } catch (e) {
      console.error('Error fetching tasks', e);
      if (!silent) {
        this.setState({ tasks: [], loading: false });
      }
    }
  };

  getSubTasksCount = (task) => {
    if (!task) return 0;
    if (Array.isArray(task.sub_tasks_parsed)) {
      return task.sub_tasks_parsed.length;
    }
    const rawSubtasks = task.sub_tasks || task.subTasks;
    if (rawSubtasks) {
      if (Array.isArray(rawSubtasks)) return rawSubtasks.length;
      try {
        let parsed = typeof rawSubtasks === 'string' ? JSON.parse(rawSubtasks) : rawSubtasks;
        while (typeof parsed === 'string') {
          parsed = JSON.parse(parsed);
        }
        if (Array.isArray(parsed)) return parsed.length;
      } catch (_) {}
    }
    return 0;
  };

  handleTimelineInlineChange = (taskId, value) => {
    let input = value || '';
    const prevVal = this.state.timelineDrafts[taskId] || '';
    const isDeleting = input.length < prevVal.length;

    // Convert dot or space to colon if user typed it as separator
    input = input.replace(/[.\s]/g, ':').replace(/:{2,}/g, ':');
    input = input.replace(/hr/gi, '').trim().replace(/[^0-9:]/g, '');

    if (input.length > 5) {
      input = input.slice(0, 5);
    }

    if (!isDeleting) {
      // Auto-format single digit 1-9 to "0X:" and advance to minutes
      if (/^[1-9]$/.test(input)) {
        input = `0${input}:`;
      } else if (/^0[0-9]$/.test(input)) {
        input = `${input}:`;
      } else if (/^\d{2}$/.test(input) && !input.endsWith(':')) {
        input = `${input}:`;
      }
    }

    this.setState((prevState) => ({
      timelineDrafts: {
        ...prevState.timelineDrafts,
        [taskId]: input
      }
    }));
  };

  handleTimelineInlineFocus = (task, e) => {
    const raw = this.state.timelineDrafts[task.id] !== undefined
      ? this.state.timelineDrafts[task.id]
      : (task.timeline || '');
    const clean = (raw || '').replace(/hr/gi, '').trim();
    this.setState((prevState) => ({
      timelineDrafts: {
        ...prevState.timelineDrafts,
        [task.id]: clean
      }
    }));
    if (e && e.target && typeof e.target.select === 'function') {
      e.target.select();
    }
  };

  handleTimelineInlineKeyDown = (task, e) => {
    if (e.key === 'Enter') {
      e.target.blur();
      return;
    }
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      e.preventDefault();
      const current = this.state.timelineDrafts[task.id] !== undefined
        ? this.state.timelineDrafts[task.id]
        : (task.timeline || '');
      const parsed = parseTimelineHoursMinutes(current) || { h: 0, m: 0 };
      const currentMinutes = parsed.h * 60 + parsed.m;
      const step = 30; // 30 minutes step
      let nextMinutes = e.key === 'ArrowUp' ? currentMinutes + step : currentMinutes - step;
      if (nextMinutes < 0) nextMinutes = 0;
      if (nextMinutes > 8 * 60) nextMinutes = 8 * 60; // Max 8 hours
      const nh = Math.floor(nextMinutes / 60);
      const nm = nextMinutes % 60;
      const formatted = `${String(nh).padStart(2, '0')}:${String(nm).padStart(2, '0')}`;
      this.setState((prevState) => ({
        timelineDrafts: {
          ...prevState.timelineDrafts,
          [task.id]: formatted
        }
      }));
    }
  };

  handleTimelineInlineBlur = async (task) => {
    const rawVal = this.state.timelineDrafts[task.id];
    if (rawVal === undefined) return;

    const trimmed = (rawVal || '').replace(/hr/gi, '').trim();
    if (!trimmed) {
      if (task.timeline) {
        const updatedTask = { ...task, timeline: '' };
        this.setState((prevState) => ({
          tasks: prevState.tasks.map((t) => (t.id === task.id ? updatedTask : t)),
          activeDrawerTask: prevState.activeDrawerTask && prevState.activeDrawerTask.id === task.id ? updatedTask : prevState.activeDrawerTask,
          timelineDrafts: {
            ...prevState.timelineDrafts,
            [task.id]: ''
          }
        }));
        try {
          await AuthApi.updateTaskTimeline(task.id, '');
        } catch (e) {
          console.error('Error clearing timeline', e);
        }
      }
      return;
    }

    const validation = validateTimeline(trimmed);
    if (!validation.isValid) {
      swal('Invalid Timeline', validation.error || 'Please enter valid hours (max 8 hours, e.g. 02:00 hr)', 'warning');
      this.setState((prevState) => ({
        timelineDrafts: {
          ...prevState.timelineDrafts,
          [task.id]: task.timeline || ''
        }
      }));
      return;
    }

    const formattedBase = clampAndFormatTimeline(trimmed);
    const finalFormatted = formattedBase ? `${formattedBase} hr` : '';

    const currentFormatted = task.timeline || '';
    if (currentFormatted === finalFormatted) {
      this.setState((prevState) => ({
        timelineDrafts: {
          ...prevState.timelineDrafts,
          [task.id]: finalFormatted
        }
      }));
      return;
    }

    const updatedTask = { ...task, timeline: finalFormatted };
    this.setState((prevState) => ({
      tasks: prevState.tasks.map((t) => (t.id === task.id ? updatedTask : t)),
      activeDrawerTask: prevState.activeDrawerTask && prevState.activeDrawerTask.id === task.id ? updatedTask : prevState.activeDrawerTask,
      timelineDrafts: {
        ...prevState.timelineDrafts,
        [task.id]: finalFormatted
      }
    }));

    try {
      await AuthApi.updateTaskTimeline(task.id, finalFormatted);
    } catch (err) {
      console.error('Error saving timeline:', err);
    }
  };

  handleTimelineSegmentSave = async (task, finalFormatted) => {
    const currentFormatted = task.timeline || '';
    if (currentFormatted === finalFormatted) {
      return;
    }

    const updatedTask = { ...task, timeline: finalFormatted };
    this.setState((prevState) => ({
      tasks: prevState.tasks.map((t) => (t.id === task.id ? updatedTask : t)),
      activeDrawerTask:
        prevState.activeDrawerTask && prevState.activeDrawerTask.id === task.id
          ? updatedTask
          : prevState.activeDrawerTask
    }));

    try {
      await AuthApi.updateTaskTimeline(task.id, finalFormatted);
    } catch (err) {
      console.error('Error saving timeline:', err);
    }
  };

  formatProjectTaskId = (taskId, projectName = '') => {
    if (!taskId) return '';
    const str = String(taskId).trim();
    if (/^[a-z]{3,4}_\d{3,}$/i.test(str)) {
      return str.toLowerCase();
    }
    const m = str.match(/^(.*?)_(\d+)$/);
    if (m) {
      const rawName = m[1] || projectName;
      const clean = rawName.replace(/[^a-zA-Z0-9]/g, '');
      const prefix = clean.length >= 4 ? clean.slice(0, 4).toLowerCase() : (clean.toLowerCase() || 'task');
      const num = parseInt(m[2], 10);
      return `${prefix}_${String(num).padStart(3, '0')}`;
    }
    return str;
  };

  normalizeTask = (task) => {
    let subtasks = [];
    const rawSubtasks = task.sub_tasks || task.subTasks;
    if (rawSubtasks) {
      try {
        let parsed = typeof rawSubtasks === 'string' ? JSON.parse(rawSubtasks) : rawSubtasks;
        while (typeof parsed === 'string') {
          parsed = JSON.parse(parsed);
        }
        subtasks = Array.isArray(parsed) ? parsed : [];
      } catch (_) {
        subtasks = [];
      }
    }

    let activityLogs = [];
    if (task.activity_logs) {
      try {
        const parsedLogs = typeof task.activity_logs === 'string' ? JSON.parse(task.activity_logs) : task.activity_logs;
        activityLogs = Array.isArray(parsedLogs) ? parsedLogs : [];
      } catch (_) {
        activityLogs = [];
      }
    }

    let filesParsed = [];
    let rawFiles = task.files;
    if (rawFiles) {
      if (typeof rawFiles === 'string') {
        try {
          rawFiles = JSON.parse(rawFiles);
          while (typeof rawFiles === 'string') {
            rawFiles = JSON.parse(rawFiles);
          }
        } catch (_) {
          rawFiles = [];
        }
      }
      if (Array.isArray(rawFiles)) {
        filesParsed = rawFiles.filter(f => f && typeof f === 'object' && (f.url || f.name || f.file_name));
      } else if (rawFiles && typeof rawFiles === 'object' && (rawFiles.url || rawFiles.name || rawFiles.file_name)) {
        filesParsed = [rawFiles];
      }
    }

    // Map database status to known column
    let status = task.status || 'Pending';
    if (status.toLowerCase() === 'todo' || status.toLowerCase() === 'to do') {
      status = 'Pending';
    }

    const normalizedTaskId = this.formatProjectTaskId(task.project_task_id, task.project_name);
    const parentTaskId = normalizedTaskId || task.id;
    const subTasksNormalized = subtasks.map((st, idx) => {
      const subNum = idx + 1;
      const rawChild = st.child_id || st.sub_task_id || `${parentTaskId}.${subNum}`;
      const dotIdx = String(rawChild).lastIndexOf('.');
      const childNum = dotIdx !== -1 ? String(rawChild).slice(dotIdx + 1) : subNum;
      const childId = `${parentTaskId}.${childNum}`;
      return {
        ...st,
        id: st.id || subNum,
        parent_id: parentTaskId,
        child_id: childId,
        sub_task_id: childId,
        name: (st.name || '').trim(),
        status: st.status || 'Pending',
        details: st.details || (st.name || '').trim()
      };
    });

    return {
      ...task,
      project_task_id: normalizedTaskId,
      status,
      sub_tasks_parsed: subTasksNormalized,
      activity_logs_parsed: activityLogs,
      files_parsed: filesParsed,
      priority: task.priority || 'Medium'
    };
  };

  // --- Drag and Drop Handling ---
  onDragEnd = async (result) => {
    const { source, destination, draggableId } = result;

    if (!destination) return;
    if (source.droppableId === destination.droppableId && source.index === destination.index) return;

    const newStatus = destination.droppableId;
    const taskId = Number(draggableId);
    const { tasks } = this.state;

    const targetTask = tasks.find(t => Number(t.id) === taskId);
    if (!targetTask) return;

    const oldStatus = targetTask.status;
    if (oldStatus === newStatus) return;

    const isDone = newStatus.toLowerCase() === 'done';
    const todayDate = moment().format('YYYY-MM-DD');

    // Optimistic UI update
    const updatedTasks = tasks.map(t => {
      if (Number(t.id) === taskId) {
        return {
          ...t,
          status: newStatus,
          ...(isDone ? { done_date: todayDate } : {})
        };
      }
      return t;
    });

    this.setState({ tasks: updatedTasks });

    // Update active drawer if open
    if (this.state.activeDrawerTask && Number(this.state.activeDrawerTask.id) === taskId) {
      this.setState({
        activeDrawerTask: {
          ...this.state.activeDrawerTask,
          status: newStatus,
          ...(isDone ? { done_date: todayDate } : {})
        }
      });
    }

    // Sync to backend DB with date and time
    try {
      const res = await AuthApi.updateTaskStatus(taskId, newStatus, isDone ? todayDate : null);
      if (!res || res.status === false) {
        // Rollback on failure
        this.setState({
          tasks: tasks.map(t => (Number(t.id) === taskId ? { ...t, status: oldStatus } : t))
        });
        swal('Error', 'Failed to update task status in database.', 'error');
      } else {
        if (isDone) {
          this.saveTaskDoneDate(taskId);
        }
        // Refresh tasks to pull latest activity logs silently without UI flicker
        this.fetchTasks(true);
      }
    } catch (err) {
      console.error('Failed to sync status change:', err);
      this.setState({
        tasks: tasks.map(t => (Number(t.id) === taskId ? { ...t, status: oldStatus } : t))
      });
    }
  };

  saveTaskDoneDate = (taskId) => {
    try {
      const todayStr = moment().format('YYYY-MM-DD');
      const historyMeta = this.getTaskHistoryMeta();
      historyMeta[taskId] = {
        ...(historyMeta[taskId] || {}),
        done_date: todayStr
      };
      ls.set('cherrypik_task_history_meta_v1', historyMeta);
      if (typeof window !== 'undefined') {
        window.localStorage.setItem('cherrypik_task_history_meta_v1', JSON.stringify(historyMeta));
      }
      if (typeof AuthApi.updateTaskDoneDate === 'function') {
        AuthApi.updateTaskDoneDate(taskId, todayStr);
      }
    } catch (_) {}
  };

  getTaskHistoryMeta = () => {
    try {
      const raw = ls.get('cherrypik_task_history_meta_v1') ||
        (typeof window !== 'undefined' ? window.localStorage.getItem('cherrypik_task_history_meta_v1') : null);
      if (typeof raw === 'string') {
        return JSON.parse(raw) || {};
      }
      return raw || {};
    } catch (_) {
      return {};
    }
  };

  parseDateMoment = (dateVal) => {
    if (!dateVal || String(dateVal).startsWith('0000-00-00')) return null;
    const str = String(dateVal).trim();
    const formats = [
      'YYYY-MM-DD HH:mm:ss',
      'YYYY-MM-DD HH:mm',
      'YYYY-MM-DDTHH:mm:ss.SSSZ',
      'YYYY-MM-DDTHH:mm:ssZ',
      'YYYY-MM-DD',
      'DD-MM-YYYY HH:mm:ss',
      'DD-MM-YYYY HH:mm',
      'DD-MM-YYYY hh:mm A',
      'DD-MM-YYYY',
      'DD/MM/YYYY HH:mm:ss',
      'DD/MM/YYYY HH:mm',
      'DD/MM/YYYY hh:mm A',
      'DD/MM/YYYY'
    ];
    let m = moment(str, formats, true);
    if (m.isValid()) return m;
    m = moment(str, formats, false);
    if (m.isValid()) return m;
    const match = str.match(/(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})/);
    if (match) {
      const parsed = moment(`${match[1]}-${match[2]}-${match[3]}`, 'DD-MM-YYYY');
      if (parsed.isValid()) return parsed;
    }
    const fallback = moment(str);
    return fallback.isValid() ? fallback : null;
  };

  isTaskInCurrentWeek = (task) => {
    if (!task) return false;

    const historyMeta = this.getTaskHistoryMeta();
    const meta = historyMeta[task.id] || {};

    const candidateDates = [
      meta.done_date,
      task.done_date,
      task.updated_at,
      task.modified_at,
      task.modify_date,
      task.task_deliver_date,
      task.task_date_time,
      task.created_at,
      task.date
    ].filter(Boolean);

    // Also inspect activity logs for recent completion timestamp if present
    if (Array.isArray(task.activity_logs_parsed)) {
      task.activity_logs_parsed.forEach(log => {
        if (log && (log.date || log.created_at || log.timestamp)) {
          const logText = String(log.activity || log.text || log.action || '').toLowerCase();
          if (logText.includes('done') || logText.includes('status')) {
            candidateDates.push(log.date || log.created_at || log.timestamp);
          }
        }
      });
    }

    const startOfWeek = moment().startOf('isoWeek').startOf('day');
    const endOfWeek = moment().endOf('isoWeek').endOf('day');
    const startOfSunWeek = moment().startOf('week').startOf('day');
    const endOfSunWeek = moment().endOf('week').endOf('day');

    for (const d of candidateDates) {
      const m = this.parseDateMoment(d);
      if (m && m.isValid()) {
        if (
          m.isBetween(startOfWeek, endOfWeek, null, '[]') ||
          m.isBetween(startOfSunWeek, endOfSunWeek, null, '[]')
        ) {
          return true;
        }
      }
    }

    // If task is Done and has no explicit completion date indicating an older week, keep it visible!
    if (String(task.status || '').toLowerCase() === 'done') {
      const explicitDoneDate = meta.done_date || task.done_date;
      if (!explicitDoneDate) {
        return true;
      }
      const m = this.parseDateMoment(explicitDoneDate);
      if (m && m.isValid()) {
        return (
          m.isBetween(startOfWeek, endOfWeek, null, '[]') ||
          m.isBetween(startOfSunWeek, endOfSunWeek, null, '[]')
        );
      }
      return true;
    }

    return true;
  };

  getTaskDateMoment = (task) => {
    if (!task) return null;
    const historyMeta = this.getTaskHistoryMeta();
    const meta = historyMeta[task.id] || {};

    const candidate =
      (String(task.status || '').toLowerCase() === 'done'
        ? (meta.done_date || task.done_date || task.updated_at || task.modified_at || task.modify_date || task.task_deliver_date)
        : null) ||
      meta.done_date ||
      task.done_date ||
      task.task_deliver_date ||
      task.task_date_time ||
      task.created_at ||
      task.date ||
      task.updated_at;

    return this.parseDateMoment(candidate);
  };

  // Sort tasks: Today's date tasks first at top, other dates of current week below (newest first)
  sortTasksTodayFirst = (tasksList) => {
    if (!Array.isArray(tasksList)) return [];
    const todayStr = moment().format('YYYY-MM-DD');
    return [...tasksList].sort((a, b) => {
      const ma = this.getTaskDateMoment(a);
      const mb = this.getTaskDateMoment(b);
      const aIsToday = Boolean(ma && ma.isValid() && ma.format('YYYY-MM-DD') === todayStr);
      const bIsToday = Boolean(mb && mb.isValid() && mb.format('YYYY-MM-DD') === todayStr);

      if (aIsToday && !bIsToday) return -1;
      if (!aIsToday && bIsToday) return 1;

      const timeA = ma && ma.isValid() ? ma.valueOf() : 0;
      const timeB = mb && mb.isValid() ? mb.valueOf() : 0;
      if (timeA !== timeB) {
        return timeB - timeA;
      }
      return Number(b.id || 0) - Number(a.id || 0);
    });
  };

  // --- Filter and Search Logic ---
  getFilteredTasks = () => {
    const { tasks, selectedProject, searchQuery, filterOnlyMyTasks, filterPriority, filterAssigneeId, filterStatus, projects } = this.state;
    const currentUserId = this.getCurrentUserId();
    const isSuperAdmin = this.isUserSuperAdmin();

    return tasks.filter(task => {
      // Active tasks (To Do, In Progress, In Discuss, Testing / Review) are always shown on the board!
      // Only the "Done" column filters for tasks completed in the current week (with today's at the top)
      const statusLower = (task.status || 'Pending').toLowerCase();
      if (statusLower === 'done' || statusLower === 'completed') {
        if (!this.isTaskInCurrentWeek(task)) {
          return false;
        }
      }

      const taskProjectName = (task.project_name || '').trim().toLowerCase();

      // For non-admin, task must be assigned to the user or created by the user
      if (!isSuperAdmin) {
        const assignedUsers = this.getAssignedUsersForTask(task);
        const taskMemberIds = this.extractIds(task.member_ids || task.developer_user_ids);
        const isAssignedToUser = Boolean(
          currentUserId && (
            Number(task.developer_user_id) === Number(currentUserId) ||
            Number(task.assign_by_id || task.assign_by) === Number(currentUserId) ||
            assignedUsers.some((u) => Number(u.id) === Number(currentUserId)) ||
            taskMemberIds.includes(Number(currentUserId))
          )
        );

        if (!isAssignedToUser) {
          return false;
        }
      }


      // Project filter
      if (selectedProject !== 'ALL' && task.project_name !== selectedProject) {
        return false;
      }

      // "Only My Tasks" filter
      if (filterOnlyMyTasks && currentUserId) {
        const assignedUsers = this.getAssignedUsersForTask(task);
        const isAssigned =
          Number(task.developer_user_id) === Number(currentUserId) ||
          assignedUsers.some((u) => Number(u.id) === Number(currentUserId));
        if (!isAssigned) {
          return false;
        }
      }

      // Priority filter
      if (filterPriority !== 'all') {
        const taskPriority = String(task.priority || '').toLowerCase();
        if (taskPriority !== filterPriority.toLowerCase()) {
          return false;
        }
      }

      // Status filter
      if (filterStatus && filterStatus !== 'all') {
        const taskStatus = (task.status || 'Pending').toLowerCase();
        const targetStatus = filterStatus.toLowerCase();
        if (taskStatus !== targetStatus) {
          return false;
        }
      }

      // Assignee Avatar filter
      if (filterAssigneeId !== 'all') {
        const assignedUsers = this.getAssignedUsersForTask(task);
        const matchesAssignee =
          Number(task.developer_user_id) === Number(filterAssigneeId) ||
          assignedUsers.some((u) => Number(u.id) === Number(filterAssigneeId));
        if (!matchesAssignee) {
          return false;
        }
      }

      // Search Query
      if (searchQuery.trim()) {
        const q = searchQuery.toLowerCase();
        const matchesTitle = task.task && task.task.toLowerCase().includes(q);
        const matchesKey = task.project_task_id && task.project_task_id.toLowerCase().includes(q);
        const matchesDev = task.developer_name && task.developer_name.toLowerCase().includes(q);
        const matchesProject = task.project_name && task.project_name.toLowerCase().includes(q);
        const matchesDesc = task.description && task.description.toLowerCase().includes(q);
        if (!matchesTitle && !matchesKey && !matchesDev && !matchesProject && !matchesDesc) {
          return false;
        }
      }

      return true;
    });
  };

  // --- Drawer Handling (Task Detail View) ---
  openTaskDrawer = async (taskOrRow) => {
    if (!taskOrRow) return;
    const rawId = taskOrRow.id;
    // Always find pristine task object from this.state.tasks to avoid JSX elements in activeDrawerTask
    const pristineTask = (this.state.tasks || []).find((t) => String(t.id) === String(rawId)) || {};

    // Build cleanTask: pristineTask is the source of truth for all string fields.
    // taskOrRow may contain JSX (from table data transforms), so ONLY take extra fields not in pristineTask from it.
    const cleanTask = {
      ...taskOrRow,
      ...pristineTask,
      id: rawId,
      task: typeof pristineTask.task === 'string'
        ? pristineTask.task
        : (typeof taskOrRow.task === 'string'
          ? taskOrRow.task
          : (taskOrRow.task?.props?.children || pristineTask.task_title || '')),
      priority: typeof pristineTask.priority === 'string'
        ? pristineTask.priority
        : (typeof taskOrRow.priority === 'string' ? taskOrRow.priority : 'Medium'),
      status: typeof pristineTask.status === 'string'
        ? pristineTask.status
        : (typeof taskOrRow.status === 'string' ? taskOrRow.status : 'Pending'),
      project_name: typeof pristineTask.project_name === 'string'
        ? pristineTask.project_name
        : (typeof taskOrRow.project_name === 'string'
          ? taskOrRow.project_name
          : (taskOrRow.project_name?.props?.children || '')),
      developer_name: typeof pristineTask.developer_name === 'string'
        ? pristineTask.developer_name
        : (typeof taskOrRow.developer_name === 'string' ? taskOrRow.developer_name : ''),
      sub_tasks_parsed: pristineTask.sub_tasks_parsed || taskOrRow.sub_tasks_parsed || [],
      activity_logs_parsed: pristineTask.activity_logs_parsed || taskOrRow.activity_logs_parsed || [],
      files_parsed: (() => {
        let rawFiles = pristineTask.files !== undefined ? pristineTask.files : taskOrRow.files;
        if (!rawFiles) return [];
        if (typeof rawFiles === 'string') {
          try {
            rawFiles = JSON.parse(rawFiles);
            while (typeof rawFiles === 'string') {
              rawFiles = JSON.parse(rawFiles);
            }
          } catch (_) {
            return [];
          }
        }
        if (Array.isArray(rawFiles)) {
          return rawFiles.filter(f => f && typeof f === 'object' && (f.url || f.name || f.file_name));
        }
        if (rawFiles && typeof rawFiles === 'object' && (rawFiles.url || rawFiles.name || rawFiles.file_name)) {
          return [rawFiles];
        }
        return [];
      })(),
    };

    this.setState({
      activeDrawerTask: cleanTask,
      drawerLoadingActivity: true,
      drawerNewComment: '',
      drawerNewSubtaskTitle: '',
      drawerActivityOpen: false,
      drawerDescEditing: false,
      drawerTaskNameEditing: false,
      drawerTaskNameError: ''
    });

    // Sync task ID into browser URL query parameter
    if (this.props.history && this.props.location) {
      const searchParams = new URLSearchParams(this.props.location.search || '');
      searchParams.set('taskId', cleanTask.project_task_id || rawId);
      this.props.history.replace({
        pathname: this.props.location.pathname,
        search: searchParams.toString()
      });
    }

    try {
      const res = await AuthApi.getActivityLogs(rawId);
      if (res && res.status && Array.isArray(res.data)) {
        this.setState({
          drawerActivity: res.data,
          drawerLoadingActivity: false
        });
      } else {
        this.setState({
          drawerActivity: cleanTask.activity_logs_parsed || [],
          drawerLoadingActivity: false
        });
      }
    } catch (_) {
      this.setState({
        drawerActivity: cleanTask.activity_logs_parsed || [],
        drawerLoadingActivity: false
      });
    }

    try {
      const taskRes = await AuthApi.getTaskById(rawId);
      if (taskRes && taskRes.status && taskRes.data) {
        const freshTask = taskRes.data;
        let freshFiles = [];
        let rFiles = freshTask.files;
        if (rFiles) {
          if (typeof rFiles === 'string') {
            try {
              rFiles = JSON.parse(rFiles);
              while (typeof rFiles === 'string') {
                rFiles = JSON.parse(rFiles);
              }
            } catch (_) {
              rFiles = [];
            }
          }
          if (Array.isArray(rFiles)) {
            freshFiles = rFiles.filter(f => f && typeof f === 'object' && (f.url || f.name || f.file_name));
          } else if (rFiles && typeof rFiles === 'object' && (rFiles.url || rFiles.name || rFiles.file_name)) {
            freshFiles = [rFiles];
          }
        }
        this.setState((prev) => {
          if (!prev.activeDrawerTask || prev.activeDrawerTask.id !== cleanTask.id) return null;
          return {
            activeDrawerTask: {
              ...prev.activeDrawerTask,
              files: freshFiles,
              files_parsed: freshFiles
            }
          };
        });
      }
    } catch (_) {}
  };

  handleDownloadFile = (file) => {
    downloadFileDirect(file);
  };

  handleViewFile = (file) => {
    this.setState({ previewFile: file });
  };

  handleClosePreview = () => {
    this.setState({ previewFile: null });
  };

  handleDrawerFileUpload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    const { activeDrawerTask } = this.state;
    if (!activeDrawerTask) return;

    this.setState({ drawerUploadingFile: true });
    try {
      const newlyUploaded = [];
      for (const file of files) {
        const uploadRes = await AuthApi.uploadTaskFile(file);
        if (uploadRes && uploadRes.status && uploadRes.data) {
          newlyUploaded.push(uploadRes.data);
        }
      }
      const existing = activeDrawerTask.files_parsed || [];
      const updatedFiles = [...existing, ...newlyUploaded];
      const updatedTask = {
        ...activeDrawerTask,
        files: updatedFiles,
        files_parsed: updatedFiles
      };
      this.setState({
        activeDrawerTask: updatedTask,
        tasks: this.state.tasks.map((t) => (t.id === activeDrawerTask.id ? updatedTask : t)),
        drawerUploadingFile: false
      });
      // Persist to backend
      const payload = this.buildTaskUpdatePayload(updatedTask, { files: updatedFiles });
      await AuthApi.updateTask(activeDrawerTask.id, payload);
    } catch (err) {
      console.error('Failed to upload file in drawer', err);
      this.setState({ drawerUploadingFile: false });
    }
    if (this.drawerFileInputRef && this.drawerFileInputRef.current) {
      this.drawerFileInputRef.current.value = '';
    }
  };

  handleDrawerFileDelete = async (idx) => {
    const { activeDrawerTask } = this.state;
    if (!activeDrawerTask) return;
    const existing = activeDrawerTask.files_parsed || [];
    const updatedFiles = existing.filter((_, i) => i !== idx);
    const updatedTask = {
      ...activeDrawerTask,
      files: updatedFiles,
      files_parsed: updatedFiles
    };
    this.setState({
      activeDrawerTask: updatedTask,
      tasks: this.state.tasks.map((t) => (t.id === activeDrawerTask.id ? updatedTask : t))
    });
    try {
      const payload = this.buildTaskUpdatePayload(updatedTask, { files: updatedFiles });
      await AuthApi.updateTask(activeDrawerTask.id, payload);
    } catch (err) {
      console.error('Failed to remove file in drawer', err);
    }
  };

  closeTaskDrawer = () => {
    const { activeDrawerTask } = this.state;
    if (activeDrawerTask) {
      const taskName = typeof activeDrawerTask.task === 'string' ? activeDrawerTask.task.trim() : '';
      if (!taskName) {
        this.setState({ drawerTaskNameError: 'Task name is required' });
        return;
      }
    }
    this.setState({
      activeDrawerTask: null,
      drawerActivity: [],
      drawerNewComment: '',
      drawerNewSubtaskTitle: '',
      drawerActivityOpen: false,
      drawerDescEditing: false,
      drawerTaskNameEditing: false,
      drawerTaskNameError: ''
    });

    // Remove taskId from browser URL query parameter
    if (this.props.history && this.props.location) {
      const searchParams = new URLSearchParams(this.props.location.search || '');
      searchParams.delete('taskId');
      searchParams.delete('task_id');
      searchParams.delete('id');
      const newQuery = searchParams.toString();
      this.props.history.replace({
        pathname: this.props.location.pathname,
        search: newQuery ? `?${newQuery}` : ''
      });
    }
  };

  fetchDrawerActivity = async (taskId) => {
    if (!taskId) return;
    try {
      const res = await AuthApi.getActivityLogs(taskId);
      if (res && res.status && Array.isArray(res.data)) {
        this.setState({
          drawerActivity: res.data,
          drawerLoadingActivity: false
        });
      } else {
        this.setState({ drawerLoadingActivity: false });
      }
    } catch (err) {
      console.error('Error fetching drawer activity:', err);
      this.setState({ drawerLoadingActivity: false });
    }
  };

  handleDrawerStatusChange = async (e) => {
    const newStatus = e.target.value;
    const { activeDrawerTask } = this.state;
    if (!activeDrawerTask) return;

    const taskId = activeDrawerTask.id;
    const isDone = String(newStatus).trim().toLowerCase() === 'done';
    const todayDate = moment().format('YYYY-MM-DD');

    this.setState({
      activeDrawerTask: {
        ...activeDrawerTask,
        status: newStatus,
        ...(isDone ? { done_date: todayDate } : {})
      },
      tasks: this.state.tasks.map(t => (t.id === taskId ? {
        ...t,
        status: newStatus,
        ...(isDone ? { done_date: todayDate } : {})
      } : t))
    });

    try {
      const res = await AuthApi.updateTaskStatus(taskId, newStatus);
      if (res && (res.status === true || res.status === 'true' || res.status === 'success' || (res.data && res.data.id) || res.id)) {
        try {
          if (isDone) {
            this.saveTaskDoneDate(taskId);
          }
          if (typeof this.fetchDrawerActivity === 'function') {
            await this.fetchDrawerActivity(taskId);
          }
          await this.fetchTasks(true);
        } catch (postErr) {
          console.error('Post status update error:', postErr);
        }
      }
    } catch (err) {
      console.error('Failed to update status', err);
    }
  };

  handleTableStatusChange = async (taskId, newStatus) => {
    const { tasks } = this.state;
    const targetTask = tasks.find((t) => Number(t.id) === Number(taskId));
    if (!targetTask) return;

    const oldStatus = targetTask.status || 'Pending';
    if (oldStatus === newStatus) return;

    const isDone = String(newStatus).trim().toLowerCase() === 'done';
    const todayDate = moment().format('YYYY-MM-DD');

    // Optimistic UI update without component reload or flicker
    const updatedTasks = tasks.map((t) =>
      Number(t.id) === Number(taskId)
        ? { ...t, status: newStatus, ...(isDone ? { done_date: todayDate } : {}) }
        : t
    );
    this.setState({
      tasks: updatedTasks,
      ...(this.state.activeDrawerTask && Number(this.state.activeDrawerTask.id) === Number(taskId)
        ? {
            activeDrawerTask: {
              ...this.state.activeDrawerTask,
              status: newStatus,
              ...(isDone ? { done_date: todayDate } : {})
            }
          }
        : {})
    });

    try {
      const res = await AuthApi.updateTaskStatus(taskId, newStatus);
      const isSuccess = Boolean(
        res &&
        (res.status === true ||
          res.status === 'true' ||
          res.status === 'success' ||
          (res.data && res.data.id) ||
          res.id)
      );

      if (isSuccess) {
        try {
          if (isDone) {
            this.saveTaskDoneDate(taskId);
          }
          if (this.state.activeDrawerTask && Number(this.state.activeDrawerTask.id) === Number(taskId)) {
            if (typeof this.fetchDrawerActivity === 'function') {
              await this.fetchDrawerActivity(taskId);
            }
          }
          await this.fetchTasks(true);
        } catch (postErr) {
          console.error('Post status update error:', postErr);
        }
      } else if (!res || res.status === false) {
        this.setState({
          tasks: tasks.map((t) =>
            Number(t.id) === Number(taskId) ? { ...t, status: oldStatus } : t
          ),
          activeDrawerTask: this.state.activeDrawerTask && Number(this.state.activeDrawerTask.id) === Number(taskId)
            ? { ...this.state.activeDrawerTask, status: oldStatus }
            : this.state.activeDrawerTask
        });
        swal('Error', (res && res.message) || 'Failed to update status in database.', 'error');
      }
    } catch (err) {
      console.error('Failed to update status', err);
      this.setState({
        tasks: tasks.map((t) =>
          Number(t.id) === Number(taskId) ? { ...t, status: oldStatus } : t
        ),
        activeDrawerTask: this.state.activeDrawerTask && Number(this.state.activeDrawerTask.id) === Number(taskId)
          ? { ...this.state.activeDrawerTask, status: oldStatus }
          : this.state.activeDrawerTask
      });
      swal('Error', 'Failed to update status in database.', 'error');
    }
  };

  handlePriorityChange = async (taskId, newPriority) => {
    const { tasks } = this.state;
    const targetTask = tasks.find((t) => Number(t.id) === Number(taskId));
    if (!targetTask) return;

    const oldPriority = targetTask.priority || 'Medium';
    if (oldPriority === newPriority) return;

    // Optimistic UI update
    const updatedTasks = tasks.map((t) =>
      Number(t.id) === Number(taskId) ? { ...t, priority: newPriority } : t
    );
    this.setState({ tasks: updatedTasks });

    if (this.state.activeDrawerTask && Number(this.state.activeDrawerTask.id) === Number(taskId)) {
      this.setState({
        activeDrawerTask: { ...this.state.activeDrawerTask, priority: newPriority }
      });
    }

    try {
      const res = await AuthApi.updateTaskPriority(taskId, newPriority);
      if (!res || res.status === false) {
        // Rollback on error
        this.setState({
          tasks: tasks.map((t) =>
            Number(t.id) === Number(taskId) ? { ...t, priority: oldPriority } : t
          )
        });
        swal('Error', (res && res.message) || 'Failed to update priority in database.', 'error');
      } else {
        try {
          if (this.state.activeDrawerTask && Number(this.state.activeDrawerTask.id) === Number(taskId)) {
            if (typeof this.fetchDrawerActivity === 'function') {
              await this.fetchDrawerActivity(taskId);
            }
          }
          await this.fetchTasks(true);
        } catch (postErr) {
          console.error('Post priority update error:', postErr);
        }
      }
    } catch (err) {
      console.error('Failed to update priority', err);
      this.setState({
        tasks: tasks.map((t) =>
          Number(t.id) === Number(taskId) ? { ...t, priority: oldPriority } : t
        )
      });
    }
  };

  handleSubtaskToggle = async (subTask) => {
    const { activeDrawerTask } = this.state;
    if (!activeDrawerTask) return;

    const newStatus = subTask.status === 'Done' ? 'Pending' : 'Done';
    const subTaskName = subTask.name;

    // Optimistic update
    const updatedSubtasks = activeDrawerTask.sub_tasks_parsed.map(st => {
      if (st.name === subTaskName) {
        return { ...st, status: newStatus };
      }
      return st;
    });

    const updatedTask = {
      ...activeDrawerTask,
      sub_tasks_parsed: updatedSubtasks
    };

    this.setState({
      activeDrawerTask: updatedTask,
      tasks: this.state.tasks.map(t => (t.id === activeDrawerTask.id ? updatedTask : t))
    });

    try {
      await AuthApi.updateSubTaskStatus(activeDrawerTask.id, subTaskName, newStatus);
      if (typeof this.fetchDrawerActivity === 'function') {
        this.fetchDrawerActivity(activeDrawerTask.id);
      }
      this.fetchTasks(true);
    } catch (err) {
      console.error('Error toggling subtask status:', err);
    }
  };

  buildTaskUpdatePayload = (task, overrides = {}) => {
    if (!task) return {};
    const devUserId = task.developer_user_id || (task.member_ids && task.member_ids[0]) || '';
    const devName = task.developer_name || '';
    const memberIds = Array.isArray(task.member_ids)
      ? task.member_ids
      : (task.developer_user_ids || (devUserId ? [Number(devUserId)] : []));

    let formattedTaskDateTime = task.task_date_time;
    if (!formattedTaskDateTime || !moment(formattedTaskDateTime).isValid()) {
      formattedTaskDateTime = moment().format('YYYY-MM-DD HH:mm:ss');
    } else {
      formattedTaskDateTime = moment(formattedTaskDateTime).format('YYYY-MM-DD HH:mm:ss');
    }

    let formattedDeliverDate = task.task_deliver_date;
    if (formattedDeliverDate && moment(formattedDeliverDate).isValid()) {
      formattedDeliverDate = moment(formattedDeliverDate).format('YYYY-MM-DD HH:mm:ss');
    } else {
      formattedDeliverDate = null;
    }

    const parentTaskId = task.project_task_id || task.id;
    const subTasksList = Array.isArray(task.sub_tasks_parsed)
      ? task.sub_tasks_parsed.map((st, idx) => {
          const subNum = idx + 1;
          const childId = st.child_id || st.sub_task_id || `${parentTaskId}.${subNum}`;
          return {
            id: st.id || subNum,
            parent_id: st.parent_id || parentTaskId,
            child_id: childId,
            sub_task_id: childId,
            name: (st.name || '').trim(),
            status: st.status || 'Pending',
            details: st.details || (st.name || '').trim()
          };
        })
      : [];

    return {
      task: (task.task || '').trim(),
      project_name: task.project_name || '',
      description: task.description || '',
      status: task.status || 'Pending',
      priority: task.priority || 'Medium',
      developer_user_id: devUserId,
      developer_name: devName,
      developer_user_ids: memberIds,
      member_ids: memberIds,
      task_date_time: formattedTaskDateTime,
      task_deliver_date: formattedDeliverDate,
      sub_tasks: subTasksList,
      files: task.files !== undefined ? task.files : (task.files_parsed || []),
      ...overrides
    };
  };

  handleAddSubtaskInline = async () => {
    const { activeDrawerTask, drawerNewSubtaskTitle } = this.state;
    if (!activeDrawerTask || !drawerNewSubtaskTitle.trim()) return;

    const parentTaskId = activeDrawerTask.project_task_id || activeDrawerTask.id;
    const subNum = (activeDrawerTask.sub_tasks_parsed || []).length + 1;
    const childId = `${parentTaskId}.${subNum}`;

    const newSubtask = {
      id: subNum,
      parent_id: parentTaskId,
      child_id: childId,
      sub_task_id: childId,
      name: drawerNewSubtaskTitle.trim(),
      status: 'Pending',
      details: drawerNewSubtaskTitle.trim()
    };

    const currentSubtasks = activeDrawerTask.sub_tasks_parsed || [];
    const updatedSubtasks = [...currentSubtasks, newSubtask];

    const updatedTask = {
      ...activeDrawerTask,
      sub_tasks_parsed: updatedSubtasks
    };

    this.setState({
      activeDrawerTask: updatedTask,
      drawerNewSubtaskTitle: '',
      tasks: this.state.tasks.map(t => (t.id === activeDrawerTask.id ? updatedTask : t))
    });

    try {
      const payload = this.buildTaskUpdatePayload(updatedTask, { sub_tasks: updatedSubtasks });
      const res = await AuthApi.updateTask(activeDrawerTask.id, payload);
      if (res && (res.status === true || res.status === 'true' || res.status === 200 || res.id)) {
        if (typeof this.fetchDrawerActivity === 'function') {
          this.fetchDrawerActivity(activeDrawerTask.id);
        }
        this.fetchTasks(true);
      } else {
        console.error('Failed to add subtask:', res);
      }
    } catch (err) {
      console.error('Failed to add subtask:', err);
    }
  };

  handleDeleteSubtask = async (subtaskIdx) => {
    const { activeDrawerTask } = this.state;
    if (!activeDrawerTask) return;

    const updatedSubtasks = (activeDrawerTask.sub_tasks_parsed || []).filter((_, i) => i !== subtaskIdx);
    const updatedTask = { ...activeDrawerTask, sub_tasks_parsed: updatedSubtasks };

    this.setState({
      activeDrawerTask: updatedTask,
      tasks: this.state.tasks.map(t => (t.id === activeDrawerTask.id ? updatedTask : t))
    });

    try {
      const payload = this.buildTaskUpdatePayload(updatedTask, { sub_tasks: updatedSubtasks });
      const res = await AuthApi.updateTask(activeDrawerTask.id, payload);
      if (res && (res.status === true || res.status === 'true' || res.status === 200 || res.id)) {
        if (typeof this.fetchDrawerActivity === 'function') {
          this.fetchDrawerActivity(activeDrawerTask.id);
        }
        this.fetchTasks(true);
      }
    } catch (err) {
      console.error('Failed to delete subtask:', err);
    }
  };

  handleStartEditSubtask = (idx, name) => {
    this.setState({ drawerEditingSubtaskIdx: idx, drawerEditingSubtaskName: name });
  };

  handleSaveSubtaskEdit = async () => {
    const { activeDrawerTask, drawerEditingSubtaskIdx, drawerEditingSubtaskName } = this.state;
    if (!activeDrawerTask || drawerEditingSubtaskIdx === null) return;
    const trimmed = drawerEditingSubtaskName.trim();
    if (!trimmed) {
      this.setState({ drawerEditingSubtaskIdx: null, drawerEditingSubtaskName: '' });
      return;
    }

    const updatedSubtasks = (activeDrawerTask.sub_tasks_parsed || []).map((st, i) =>
      i === drawerEditingSubtaskIdx ? { ...st, name: trimmed, details: trimmed } : st
    );
    const updatedTask = { ...activeDrawerTask, sub_tasks_parsed: updatedSubtasks };

    this.setState({
      activeDrawerTask: updatedTask,
      drawerEditingSubtaskIdx: null,
      drawerEditingSubtaskName: '',
      tasks: this.state.tasks.map(t => (t.id === activeDrawerTask.id ? updatedTask : t))
    });

    try {
      const payload = this.buildTaskUpdatePayload(updatedTask, { sub_tasks: updatedSubtasks });
      const res = await AuthApi.updateTask(activeDrawerTask.id, payload);
      if (res && (res.status === true || res.status === 'true' || res.status === 200 || res.id)) {
        if (typeof this.fetchDrawerActivity === 'function') {
          this.fetchDrawerActivity(activeDrawerTask.id);
        }
        this.fetchTasks(true);
      }
    } catch (err) {
      console.error('Failed to save subtask edit:', err);
    }
  };

  handleSaveDrawerTaskDetails = async () => {
    const { activeDrawerTask } = this.state;
    if (!activeDrawerTask || !activeDrawerTask.id) return;

    const taskName = typeof activeDrawerTask.task === 'string' ? activeDrawerTask.task.trim() : '';
    if (!taskName) {
      this.setState({ drawerTaskNameError: 'Task name is required' });
      return;
    } else if (this.state.drawerTaskNameError) {
      this.setState({ drawerTaskNameError: '' });
    }

    try {
      const payload = this.buildTaskUpdatePayload(activeDrawerTask);
      const res = await AuthApi.updateTask(activeDrawerTask.id, payload);
      if (res && (res.status === true || res.status === 'true' || res.status === 200 || res.id)) {
        if (typeof this.fetchDrawerActivity === 'function') {
          this.fetchDrawerActivity(activeDrawerTask.id);
        }
        this.fetchTasks(true);
      } else {
        console.error('Failed to update task details:', res);
      }
    } catch (err) {
      console.error('Failed to update task details:', err);
    }
  };

  handleDeleteTask = async (taskId) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this task?",
      icon: "warning",
      buttons: ["Cancel", "Yes"],
      dangerMode: true
    }).then(async (confirm) => {
      if (confirm) {
        swal({
          title: "Loading",
          text: "Please wait...",
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
          content: createSwalLoaderNode()
        });

        try {
          const res = await AuthApi.deletetask(taskId);
          if (res && res.status) {
            swal({
              title: "Success!",
              text: "Task deleted successfully",
              icon: "success"
            });
            this.setState({
              activeDrawerTask: null,
              tasks: this.state.tasks.filter(t => Number(t.id) !== Number(taskId))
            });
          } else {
            swal('Error', (res && res.message) || 'Failed to delete task.', 'error');
          }
        } catch (err) {
          swal('Error', 'An error occurred while deleting task.', 'error');
        }
      }
    });
  };

  // --- Create Task Modal Handling ---
  openCreateModal = (preselectedStatus = 'Pending') => {
    const { projects, selectedProject } = this.state;
    const defaultProject = selectedProject !== 'ALL' ? selectedProject : (projects[0]?.project_name || '');

    this.setState({
      isCreateModalOpen: true,
      createTaskForm: {
        task: '',
        project_name: defaultProject,
        developer_user_id: '',
        developer_name: '',
        status: preselectedStatus,
        priority: 'Medium',
        task_date_time: this.getCurrentDateTimeString(),
        task_deliver_date: this.getDefaultDeliverDateString(),
        description: '',
        subTasks: []
      },
      newSubtaskInput: ''
    });
  };

  closeCreateModal = () => {
    this.setState({ isCreateModalOpen: false, createTaskSubmitting: false });
  };

  handleCreateFormChange = (field, value) => {
    if (field === 'developer_user_id') {
      const dev = this.state.allUsers.find(u => Number(u.id) === Number(value));
      this.setState({
        createTaskForm: {
          ...this.state.createTaskForm,
          developer_user_id: value,
          developer_name: dev ? dev.firstName : ''
        }
      });
    } else {
      this.setState({
        createTaskForm: {
          ...this.state.createTaskForm,
          [field]: value
        }
      });
    }
  };

  handleAddSubtaskToModal = () => {
    const { newSubtaskInput, createTaskForm } = this.state;
    if (!newSubtaskInput.trim()) return;

    this.setState({
      createTaskForm: {
        ...createTaskForm,
        subTasks: [
          ...createTaskForm.subTasks,
          { name: newSubtaskInput.trim(), status: 'Pending', details: '' }
        ]
      },
      newSubtaskInput: ''
    });
  };

  handleRemoveSubtaskFromModal = (index) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this subtask?",
      icon: "warning",
      buttons: ["Cancel", "Yes"],
      dangerMode: true
    }).then((confirm) => {
      if (confirm) {
        const { createTaskForm } = this.state;
        this.setState({
          createTaskForm: {
            ...createTaskForm,
            subTasks: createTaskForm.subTasks.filter((_, i) => i !== index)
          }
        });
        swal({
          title: "Success!",
          text: "Subtask deleted successfully",
          icon: "success"
        });
      }
    });
  };

  handleCreateTaskSubmit = async (e) => {
    e.preventDefault();
    const { createTaskForm } = this.state;

    if (!createTaskForm.task.trim()) {
      swal('Required', 'Please enter a task summary / title.', 'warning');
      return;
    }
    if (!createTaskForm.project_name) {
      swal('Required', 'Please select a project.', 'warning');
      return;
    }
    const targetProj = (this.state.projects || []).find((p) => p.project_name === createTaskForm.project_name);
    if (targetProj && Number(targetProj.status) !== 1) {
      swal('Inactive Project', 'Tasks cannot be added to an inactive project. Please activate the project first.', 'warning');
      return;
    }

    this.setState({ createTaskSubmitting: true });

    try {
      const payload = {
        ...createTaskForm,
        subTasks: createTaskForm.subTasks
      };

      const res = await AuthApi.createTask(payload);
      if (res && res.status) {
        swal('Success', 'Task created successfully!', 'success');
        this.closeCreateModal();
        await this.fetchTasks();
      } else {
        let errorMsg = 'Failed to create task.';
        if (res) {
          if (res.error && typeof res.error === 'object') {
            const errorList = Object.values(res.error).flat().filter(Boolean);
            if (errorList.length > 0) {
              errorMsg = errorList.join('\n');
            } else if (res.message) {
              errorMsg = res.message;
            }
          } else if (res.message) {
            errorMsg = res.message;
          }
        }
        swal('Error', errorMsg, 'error');
      }
    } catch (err) {
      console.error('Error creating task:', err);
      swal('Error', 'An unexpected error occurred while saving to database.', 'error');
    } finally {
      this.setState({ createTaskSubmitting: false });
    }
  };

  handleViewChange = (view) => {
    ls.set('task_current_view', view);
    this.setState({ currentView: view });
  };

  openAddProjectModal = () => {
    this.setState({
      isAddProjectModalOpen: true,
      addProjectSubmitting: false,
      addProjectForm: {
        project_name: '',
        description: '',
        start_date: '',
        target_date: '',
        member_ids: []
      },
      addProjectFiles: [],
      addProjectMilestones: [],
      newMilestoneInput: '',
      projectUserPopoverAnchor: null,
      projectUserSearchQuery: ''
    });
  };

  closeAddProjectModal = () => {
    this.setState({
      isAddProjectModalOpen: false,
      addProjectSubmitting: false,
      projectUserPopoverAnchor: null
    });
  };

  handleAddProjectFormChange = (field, value) => {
    this.setState((prev) => ({
      addProjectForm: {
        ...prev.addProjectForm,
        [field]: value
      }
    }));
  };

  handleToggleProjectMember = (userId) => {
    const { addProjectForm } = this.state;
    const current = addProjectForm.member_ids || [];
    const exists = current.includes(userId);
    const updated = exists ? current.filter((id) => id !== userId) : [...current, userId];
    this.setState({
      addProjectForm: {
        ...addProjectForm,
        member_ids: updated
      }
    });
  };

  handleProjectFileSelect = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const selected = Array.from(e.target.files);
      this.setState((prev) => ({
        addProjectFiles: [...prev.addProjectFiles, ...selected]
      }));
    }
  };

  handleRemoveProjectFile = (index) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to remove this file?",
      icon: "warning",
      buttons: ["Cancel", "Yes"],
      dangerMode: true
    }).then((confirm) => {
      if (confirm) {
        this.setState((prev) => ({
          addProjectFiles: prev.addProjectFiles.filter((_, i) => i !== index)
        }));
      }
    });
  };

  handleAddProjectMilestonePoint = () => {
    const { newMilestoneInput, addProjectMilestones } = this.state;
    if (!newMilestoneInput.trim()) return;

    // Splits paragraphs or multiple lines automatically into distinct bullet points
    const lines = newMilestoneInput
      .split('\n')
      .map((l) => l.trim().replace(/^[-•*]\s*/, ''))
      .filter(Boolean);

    this.setState({
      addProjectMilestones: [...addProjectMilestones, ...lines],
      newMilestoneInput: ''
    });
  };

  getProjectAssignees = (projectName) => {
    const { projects, activeUsers, allUsers } = this.state;
    const usersPool = (activeUsers && activeUsers.length > 0) ? activeUsers : (allUsers || []);
    if (!projectName) return usersPool;

    const proj = (projects || []).find(
      (p) => String(p.project_name || '').trim().toLowerCase() === String(projectName).trim().toLowerCase() ||
             String(p.id) === String(projectName)
    );
    if (!proj) return usersPool;

    const extract = (raw) => {
      if (!raw) return [];
      if (Array.isArray(raw)) {
        return raw.map((item) => (typeof item === 'object' && item !== null ? (item.id || item.user_id) : item)).map(Number).filter((id) => !isNaN(id));
      }
      if (typeof raw === 'string') {
        try {
          const parsed = JSON.parse(raw);
          if (Array.isArray(parsed)) {
            return parsed.map((item) => (typeof item === 'object' && item !== null ? (item.id || item.user_id) : item)).map(Number).filter((id) => !isNaN(id));
          }
        } catch (_) {
          return raw.split(',').map(Number).filter((id) => !isNaN(id));
        }
      }
      if (typeof raw === 'number') return [raw];
      return [];
    };

    const assignedIds = Array.from(new Set([
      ...extract(proj.member_ids),
      ...extract(proj.lead_ids),
      ...extract(proj.members),
      ...extract(proj.developer_id)
    ]));

    if (assignedIds.length === 0) return usersPool;
    const filtered = usersPool.filter((u) => assignedIds.includes(Number(u.id)));
    return filtered.length > 0 ? filtered : usersPool;
  };

  handleRemoveProjectMilestone = (index) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this milestone?",
      icon: "warning",
      buttons: ["Cancel", "Yes"],
      dangerMode: true
    }).then((confirm) => {
      if (confirm) {
        this.setState((prev) => ({
          addProjectMilestones: prev.addProjectMilestones.filter((_, i) => i !== index)
        }));
      }
    });
  };

  handleAddProjectSubmit = async (e) => {
    e.preventDefault();
    const { addProjectForm, addProjectFiles, newMilestoneInput, addProjectMilestones } = this.state;
    if (!addProjectForm.project_name.trim()) {
      swal('Required', 'Please enter a project name.', 'warning');
      return;
    }

    if (addProjectForm.start_date) {
      const m = moment(addProjectForm.start_date, ['YYYY-MM-DD', 'DD/MM/YYYY'], true);
      if (!m.isValid() || m.year() < 1900 || m.year() > 2099) {
        swal('Invalid Date', 'Please enter a valid start date (1900-2099).', 'warning');
        return;
      }
    }
    if (addProjectForm.target_date) {
      const m = moment(addProjectForm.target_date, ['YYYY-MM-DD', 'DD/MM/YYYY'], true);
      if (!m.isValid() || m.year() < 1900 || m.year() > 2099) {
        swal('Invalid Date', 'Please enter a valid end date (1900-2099).', 'warning');
        return;
      }
    }

    if (addProjectForm.start_date && addProjectForm.target_date && addProjectForm.target_date < addProjectForm.start_date) {
      swal('Invalid Date', 'End date cannot be before start date.', 'warning');
      return;
    }

    this.setState({ addProjectSubmitting: true });

    try {
      const memberIds = (addProjectForm.member_ids || []).map(Number);
      const milestoneText = (newMilestoneInput || addProjectForm.description || '').trim();
      const milestoneLines = milestoneText
        ? milestoneText.split(/\r?\n/).map((l) => l.trim()).filter(Boolean)
        : (addProjectMilestones || []);

      const milestonesPayload = milestoneLines.map((line) => {
        const text = typeof line === 'string' ? line : (line.name || '');
        return {
          name: text.length > 250 ? text.slice(0, 245) + '...' : text,
          description: text.length > 250 ? text.slice(0, 1000) : null,
          dueDate: null
        };
      });

      const payload = {
        project_name: addProjectForm.project_name.trim(),
        summary: null,
        priority: 'No priority',
        start_date: addProjectForm.start_date || null,
        target_date: addProjectForm.target_date || null,
        description: milestoneText || null,
        lead_id: memberIds.length > 0 ? memberIds[0] : null,
        lead_ids: memberIds,
        member_ids: memberIds,
        milestones: milestonesPayload
      };

      const res = await AuthApi.createProject(payload);
      if (res && (res.status === true || res.status === 200 || res.success)) {
        const createdProjectId = (res.data && res.data.id) || res.id;

        // Upload any attached documents/files
        if (createdProjectId && addProjectFiles && addProjectFiles.length > 0) {
          try {
            await Promise.all(
              addProjectFiles.map((file) =>
                AuthApi.uploadProjectResource(createdProjectId, file, file.name)
              )
            );
          } catch (uploadErr) {
            console.error('Error uploading project files:', uploadErr);
          }
        }

        swal('Success', (res && res.message) || 'Project created successfully!', 'success');
        this.closeAddProjectModal();

        // Refresh project list
        const projectsRes = await AuthApi.getProject();
        const projectsData = (projectsRes && projectsRes.data) || projectsRes || [];
        const allActiveProjects = Array.isArray(projectsData) ? projectsData.filter((p) => !p.deleted) : [];
        const updatedProjects = this.filterProjectsByPermission(allActiveProjects);

        this.setState({
          projects: updatedProjects,
          selectedProject: addProjectForm.project_name.trim(),
          createTaskForm: {
            ...this.state.createTaskForm,
            project_name: addProjectForm.project_name.trim()
          }
        });
      } else {
        swal('Error', (res && res.message) || 'Failed to create project.', 'error');
      }
    } catch (err) {
      console.error('Error creating project:', err);
      swal('Error', 'An unexpected error occurred while creating project.', 'error');
    } finally {
      this.setState({ addProjectSubmitting: false });
    }
  };

  render() {
    const {
      projects,
      selectedProject,
      allUsers,
      activeUsers,
      userPopoverAnchor,
      userSearchQuery,
      loading,
      currentView,
      searchQuery,
      filterOnlyMyTasks,
      filterPriority,
      filterAssigneeId,
      filterStatus,
      activeDrawerTask,
      drawerActivity,
      drawerLoadingActivity,
      drawerNewSubtaskTitle,
      drawerActiveTab,
      drawerEditingSubtaskIdx,
      drawerEditingSubtaskName,
      isCreateModalOpen,
      createTaskSubmitting,
      createTaskForm,
      newSubtaskInput,
      isAddProjectModalOpen,
      addProjectSubmitting,
      addProjectForm,
      addProjectFiles,
      addProjectMilestones,
      newMilestoneInput,
      projectUserPopoverAnchor,
      projectUserSearchQuery
    } = this.state;

    const selectedUserObj = (allUsers || []).find((u) => Number(u.id) === Number(filterAssigneeId));
    const selectedUserDisplayName = selectedUserObj
      ? (selectedUserObj.firstName ? `${selectedUserObj.firstName} ${selectedUserObj.lastName || ''}`.trim() : selectedUserObj.name)
      : 'All Users';

    const filteredTasks = this.getFilteredTasks();

    const pageContent = (
      <div style={{ marginBottom: "11%" }}>
        <div className="holiday-breadcrumb-card">
          <Breadcrumb
            {...this.props}
            primaryPageName="Tasks"
            primaryPageLink="/tasks"
            isSecondaryPage={false}
            secondaryPageName=""
          />
        </div>

        <Card
          className="holiday-table-shell tm-unified-shell"
          style={{
            padding: "16px 20px",
            minHeight: "auto",
            height: "auto",
            overflow: "visible",
            marginBottom: "20px",
            position: "relative"
          }}
        >
          {/* Top Header Row */}
          <div className="tm-toolbar-top-row">
            <div className="tm-title-group">
              <Typography
                variant="h2"
                className="shared-table-title"
                style={{
                  fontSize: "1.15rem",
                  fontWeight: 700,
                  color: "#036dda",
                  margin: 0,
                  letterSpacing: "-0.01em"
                }}
              >
                Task Management
              </Typography>
            </div>

            <div className="tm-header-actions" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              {this.isUserSuperAdmin() && (
                <Button
                  variant="contained"
                  color="primary"
                  className="common-action-button common-add-button"
                  style={{ textTransform: "none", borderRadius: "8px", fontWeight: 600, display: "flex", alignItems: "center" }}
                  onClick={() => this.props.history.push('/manageproject')}
                >
                  <SettingsIcon style={{ fontSize: 17, marginRight: 5 }} />
                  Manage Projects
                </Button>
              )}

              <Button
                variant="contained"
                color="primary"
                className="common-action-button common-add-button"
                style={{ textTransform: "none", borderRadius: "8px", fontWeight: 600, display: "flex", alignItems: "center" }}
                onClick={() => this.props.history.push('/tasks/history')}
              >
                <HistoryIcon style={{ fontSize: 18, marginRight: 5 }} />
                Task History
              </Button>

              {this.isUserSuperAdmin() && (
                <Button
                  variant="contained"
                  color="primary"
                  className="common-action-button common-add-button"
                  style={{ textTransform: "none", borderRadius: "8px", fontWeight: 600, display: "flex", alignItems: "center" }}
                  onClick={() => this.props.history.push('/addproject')}
                >
                  <AddIcon style={{ fontSize: 18, marginRight: 4 }} />
                  Add Project
                </Button>
              )}

              <Button
                variant="contained"
                color="primary"
                className="common-action-button common-add-button"
                style={{ textTransform: "none", borderRadius: "8px", fontWeight: 600, display: "flex", alignItems: "center", whiteSpace: 'nowrap', flexShrink: 0 }}
                onClick={() => this.props.history.push('/addtask')}
              >
                <AddIcon style={{ fontSize: 18, marginRight: 4 }} />
                Add Task
              </Button>
            </div>
          </div>

          {/* Filter Toolbar Row */}
          <div className="tm-filters-row">
            {/* Project Filter */}
            <FormControl variant="outlined" className="holiday-year-filter tm-filter-item-project" style={{ width: 175, minWidth: 175, margin: 0 }}>
              <Select
                value={selectedProject}
                onChange={(e) => {
                  this.setState({ selectedProject: e.target.value });
                }}
                IconComponent={(props) => <ExpandMoreIcon {...props} style={{ color: '#036dda', cursor: 'pointer' }} />}
                style={{ height: "40px" }}
                MenuProps={{
                  disableScrollLock: true,
                  PaperProps: {
                    className: "holiday-year-menu",
                  },
                }}
              >
                <MenuItem value="ALL">All Projects ({projects.length})</MenuItem>
                {projects.map((p) => (
                  <MenuItem key={p.id || p.project_name} value={p.project_name}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', gap: 8 }}>
                      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {p.project_name}
                      </span>
                      {p.status === 0 && (
                        <span style={{ fontSize: '10px', color: '#64748b', backgroundColor: '#f1f5f9', padding: '1px 5px', borderRadius: 4, fontWeight: 700, flexShrink: 0 }}>
                          Inactive
                        </span>
                      )}
                    </div>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Quick Status, Edit & Delete icons for selected project if Admin */}
            {this.isUserSuperAdmin() && selectedProject !== 'ALL' && (() => {
              const p = projects.find((proj) => proj.project_name === selectedProject);
              const isInactive = p && p.status === 0;
              return (
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  {/* Status indicator / quick toggle */}
                  <Tooltip title={isInactive ? "Click to Mark Project Active" : "Click to Mark Project Inactive"} arrow>
                    <Chip
                      size="small"
                      label={isInactive ? "Inactive" : "Active"}
                      onClick={() => p && this.handleSetProjectStatus(p, isInactive ? 1 : 0)}
                      style={{
                        cursor: 'pointer',
                        fontWeight: 700,
                        fontSize: '11px',
                        height: 28,
                        backgroundColor: isInactive ? '#f1f5f9' : '#dcfce7',
                        color: isInactive ? '#64748b' : '#15803d',
                        border: isInactive ? '1px solid #cbd5e1' : '1px solid #86efac',
                      }}
                    />
                  </Tooltip>

                  <Tooltip title="Edit Selected Project" arrow>
                    <IconButton
                      size="small"
                      onClick={() => {
                        if (p) this.props.history.push('/editproject/' + p.id);
                      }}
                      style={{
                        backgroundColor: '#eff6ff',
                        color: '#036dda',
                        border: '1px solid #bfdbfe',
                        padding: 6,
                        borderRadius: 6,
                      }}
                      aria-label="Edit project"
                    >
                      <EditIcon style={{ fontSize: 17 }} />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Delete Selected Project" arrow>
                    <IconButton
                      size="small"
                      onClick={() => {
                        if (p) this.handleDeleteProject(p);
                      }}
                      style={{
                        backgroundColor: '#fef2f2',
                        color: '#ef4444',
                        border: '1px solid #fecaca',
                        padding: 6,
                        borderRadius: 6,
                      }}
                      aria-label="Delete project"
                    >
                      <DeleteOutlineIcon style={{ fontSize: 17 }} />
                    </IconButton>
                  </Tooltip>
                </div>
              );
            })()}

            {/* Select User Dropdown (Attendance Style Searchable Popover - Active Users Only) */}
            <div className="tm-user-filter-item tm-filter-item-user" style={{ position: 'relative', width: 160, margin: 0 }}>
              <TextField
                className="attendance-header-field"
                variant="outlined"
                value={filterAssigneeId === 'all' ? 'Select User' : selectedUserDisplayName}
                onClick={(e) => this.setState({ userPopoverAnchor: e.currentTarget })}
                style={{ width: 160, margin: 0 }}
                InputProps={{
                  readOnly: true,
                  style: {
                    cursor: 'pointer',
                    height: '40px',
                    borderRadius: '8px'
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <ExpandMoreIcon style={{ cursor: 'pointer', color: '#036dda' }} />
                    </InputAdornment>
                  ),
                }}
              />

              <Popover
                open={Boolean(userPopoverAnchor)}
                anchorEl={userPopoverAnchor}
                onClose={() => this.setState({ userPopoverAnchor: null, userSearchQuery: '' })}
                disableScrollLock
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                PaperProps={{
                  className: 'attendance-user-popover-paper',
                  style: {
                    width: 280,
                    marginTop: 5,
                    borderRadius: 8,
                    boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
                  }
                }}
              >
                <Box p={1.5} className="attendance-user-popover-header">
                  <Typography
                    variant="subtitle2"
                    className="attendance-user-popover-title"
                    style={{
                      fontWeight: 700,
                      marginBottom: 8,
                      color: '#ffffff'
                    }}
                  >
                    Select User
                  </Typography>
                  <TextField
                    className="common-user-search-field"
                    fullWidth
                    size="small"
                    placeholder="Search users..."
                    variant="outlined"
                    value={userSearchQuery}
                    onChange={(e) => this.setState({ userSearchQuery: e.target.value })}
                    InputProps={{
                      style: {
                        backgroundColor: '#ffffff',
                        borderRadius: '4px',
                        height: '36px'
                      },
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon fontSize="small" />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
                <Divider />
                <div style={{ maxHeight: 260, overflowY: 'auto' }}>
                  <MenuItem 
                    className={`attendance-user-option ${filterAssigneeId === 'all' ? 'attendance-user-selected' : ''}`}
                    selected={filterAssigneeId === 'all'}
                    onClick={() => this.setState({ filterAssigneeId: 'all', userPopoverAnchor: null, userSearchQuery: '' })}
                    style={{
                      padding: '8px 16px',
                      backgroundColor: filterAssigneeId === 'all' ? '#036dda' : undefined,
                      color: filterAssigneeId === 'all' ? '#ffffff' : undefined,
                    }}
                  >
                    <ListItemText
                      primary="All Users"
                      primaryTypographyProps={{
                        style: {
                          color: filterAssigneeId === 'all' ? '#ffffff' : 'inherit',
                          fontWeight: filterAssigneeId === 'all' ? 600 : 400,
                        }
                      }}
                    />
                    {filterAssigneeId === 'all' && <CheckIcon style={{ color: '#ffffff', fontSize: '1.2rem', marginLeft: 'auto' }} />}
                  </MenuItem>
                  {(activeUsers || []).filter((u) => {
                    const q = (userSearchQuery || '').toLowerCase();
                    const name = (u.firstName ? `${u.firstName} ${u.lastName || ''}` : u.name || '').toLowerCase();
                    return name.includes(q);
                  }).map((user, index) => {
                    const displayName = user.firstName ? `${user.firstName} ${user.lastName || ''}`.trim() : user.name;
                    const isSelected = Number(filterAssigneeId) === Number(user.id);
                    return (
                      <MenuItem 
                        className={`attendance-user-option ${isSelected ? 'attendance-user-selected' : ''}`}
                        key={user.id || index} 
                        selected={isSelected}
                        onClick={() => this.setState({ filterAssigneeId: user.id, userPopoverAnchor: null, userSearchQuery: '' })}
                        style={{
                          padding: '8px 16px',
                          backgroundColor: isSelected ? '#036dda' : undefined,
                          color: isSelected ? '#ffffff' : undefined,
                        }}
                      >
                        <Box display="flex" alignItems="center" width="100%">
                          <Avatar 
                            src={user.photo || ''} 
                            style={{
                              width: 28,
                              height: 28,
                              marginRight: 10,
                              fontSize: '0.8rem',
                              border: isSelected ? '2px solid #ffffff' : 'none'
                            }}
                          >
                            {this.getInitials(displayName)}
                          </Avatar>
                          <ListItemText
                            primary={displayName}
                            primaryTypographyProps={{
                              style: {
                                color: isSelected ? '#ffffff' : 'inherit',
                                fontWeight: isSelected ? 600 : 400,
                              }
                            }}
                          />
                          {isSelected && <CheckIcon style={{ color: '#ffffff', fontSize: '1.2rem', marginLeft: 'auto' }} />}
                        </Box>
                      </MenuItem>
                    );
                  })}
                </div>
              </Popover>
            </div>

            {/* Status Filter Dropdown */}
            <FormControl variant="outlined" className="holiday-year-filter tm-filter-item-status" style={{ width: 160, minWidth: 160, margin: 0 }}>
              <Select
                value={filterStatus}
                onChange={(e) => this.setState({ filterStatus: e.target.value })}
                IconComponent={(props) => <ExpandMoreIcon {...props} style={{ color: '#036dda', cursor: 'pointer' }} />}
                style={{ height: "40px" }}
                MenuProps={{
                  disableScrollLock: true,
                  PaperProps: {
                    className: "holiday-year-menu",
                  },
                }}
              >
                <MenuItem value="all">All Status</MenuItem>
                <MenuItem value="Backlog">Backlog</MenuItem>
                <MenuItem value="Pending">To Do</MenuItem>
                <MenuItem value="In Progress">In Progress</MenuItem>
                <MenuItem value="In Discuss">In Discuss</MenuItem>
                <MenuItem value="Testing">Testing / Review</MenuItem>
                <MenuItem value="Done">Done</MenuItem>
              </Select>
            </FormControl>



            {/* Priority Filter Dropdown */}
            <FormControl variant="outlined" className="holiday-year-filter tm-filter-item-priority" style={{ width: 140, minWidth: 140, margin: 0 }}>
              <Select
                value={filterPriority}
                onChange={(e) => this.setState({ filterPriority: e.target.value })}
                IconComponent={(props) => <ExpandMoreIcon {...props} style={{ color: '#036dda', cursor: 'pointer' }} />}
                style={{ height: "40px" }}
                MenuProps={{
                  disableScrollLock: true,
                  PaperProps: {
                    className: "holiday-year-menu",
                  },
                }}
              >
                <MenuItem value="all">All Priority</MenuItem>
                <MenuItem value="Urgent">Urgent</MenuItem>
                <MenuItem value="High">High</MenuItem>
                <MenuItem value="Medium">Medium</MenuItem>
                <MenuItem value="Low">Low</MenuItem>
              </Select>
            </FormControl>

            {/* View Switcher: Board vs List (Positioned at far right of filter toolbar) */}
            <div className="tm-view-switch">
              <button
                type="button"
                className={`tm-view-btn ${currentView === 'board' ? 'active' : ''}`}
                onClick={() => this.handleViewChange('board')}
              >
                <ViewColumnIcon style={{ fontSize: 17 }} />
                Board
              </button>
              <button
                type="button"
                className={`tm-view-btn ${currentView === 'list' ? 'active' : ''}`}
                onClick={() => this.handleViewChange('list')}
              >
                <FormatListBulletedIcon style={{ fontSize: 17 }} />
                List
              </button>
            </div>
          </div>

          <div className="tm-shell-divider" />

          {/* Loading Indicator */}
          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '60px 0' }}>
              <CircularProgress style={{ color: '#0052cc' }} />
            </div>
          ) : currentView === 'board' ? (
            /* KANBAN BOARD VIEW */
            <DragDropContext onDragEnd={this.onDragEnd}>
              <div className="tm-board-grid">
                {(filterStatus === 'all'
                  ? STATUS_COLUMNS
                  : ALL_STATUS_COLUMNS.filter((c) => c.id.toLowerCase() === filterStatus.toLowerCase())
                ).map((col) => {
                  const rawColTasks = filteredTasks.filter(
                    (t) => (t.status || 'Pending').toLowerCase() === col.id.toLowerCase()
                  );
                  const colTasks = this.sortTasksTodayFirst(rawColTasks);

                  return (
                    <div key={col.id} className="tm-column">
                      <div className="tm-column-header">
                        <div className="tm-column-header-left">
                          <span
                            className="tm-column-status-dot"
                            style={{ backgroundColor: col.dot }}
                          />
                          <h3 className="tm-column-title">{col.label}</h3>
                          <span className="tm-column-badge">{colTasks.length}</span>
                        </div>
                      </div>

                      <Droppable droppableId={col.id}>
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            className={`tm-droppable-area ${
                              snapshot.isDraggingOver ? 'is-dragging-over' : ''
                            }`}
                          >
                            {colTasks.length === 0 ? (
                              <div className="tm-column-empty">
                                {`No tasks in ${col.label}`}
                              </div>
                            ) : (
                              colTasks.map((task, index) => {
                                const dueInfo = this.getCardDueDateInfo(task);

                                return (
                                  <Draggable
                                    key={String(task.id)}
                                    draggableId={String(task.id)}
                                    index={index}
                                  >
                                    {(dragProvided, dragSnapshot) => (
                                      <div
                                        ref={dragProvided.innerRef}
                                        {...dragProvided.draggableProps}
                                        {...dragProvided.dragHandleProps}
                                        className={`tm-card ${
                                          dragSnapshot.isDragging ? 'is-dragging' : ''
                                        }`}
                                        onClick={() => this.openTaskDrawer(task)}
                                      >
                                        <div className="tm-card-top">
                                          {task.project_task_id || task.project_name ? (
                                            <span
                                              className="tm-card-project-pill tm-card-task-id-pill"
                                              title={task.project_name ? `${task.project_name} (${task.project_task_id || 'No ID'})` : task.project_task_id}
                                              style={{
                                                fontWeight: 600,
                                                letterSpacing: '0.2px'
                                              }}
                                            >
                                              {task.project_task_id || task.project_name}
                                            </span>
                                          ) : (
                                            <span />
                                          )}

                                          <div className="tm-card-assignee" style={{ minHeight: 26 }}>
                                            {this.renderAssigneeAvatars(task, true)}
                                          </div>
                                        </div>

                                        <h4 className="tm-card-title" title={typeof task.task === 'string' ? task.task.replace(/\s+/g, ' ').trim() : task.task}>
                                          {typeof task.task === 'string' ? task.task.replace(/\s+/g, ' ').trim() : task.task}
                                          {this.getSubTasksCount(task) > 0 && (
                                            <span
                                              className="tm-subtask-count"
                                              style={{
                                                marginLeft: '6px',
                                                fontWeight: 600,
                                                color: '#d32f2f',
                                                fontSize: '0.88em',
                                                whiteSpace: 'nowrap'
                                              }}
                                              title={`${this.getSubTasksCount(task)} sub task${this.getSubTasksCount(task) > 1 ? 's' : ''}`}
                                            >
                                              ({this.getSubTasksCount(task)})
                                            </span>
                                          )}
                                        </h4>

                                        <div className="tm-card-footer">
                                          <span
                                            className={`tm-card-priority-badge tm-priority-${(
                                              task.priority || 'Medium'
                                            ).toLowerCase()}`}
                                          >
                                            {task.priority || 'Medium'}
                                          </span>

                                          {dueInfo && (
                                            <span
                                              className={`tm-card-date-badge tm-date-${dueInfo.status}`}
                                              title={`${dueInfo.label}: ${dueInfo.text}`}
                                            >
                                              <CalendarTodayIcon className="tm-date-icon" />
                                              <span>{dueInfo.text}</span>
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                );
                              })
                            )}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </div>
                  );
                })}
              </div>
            </DragDropContext>
          ) : (
            /* LIST VIEW (EMS TABLE COMPONENT) */
            <div className="tm-table-view-wrapper">
              <TableComponent
                {...this.props}
                tableTh={TASK_TABLE_HEADERS}
                tableData={this.sortTasksTodayFirst(filteredTasks).map((task) => ({
                  ...task,
                  project_task_id: (
                    <span
                      style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                      onClick={(e) => {
                        e.stopPropagation();
                        this.openTaskDrawer(task);
                      }}
                      title={`Click to view ${task.project_task_id || 'task'}`}
                    >
                      {task.project_task_id || `TASK-${task.id}`}
                    </span>
                  ),
                  task: (() => {
                    const subCount = this.getSubTasksCount(task);
                    return (
                      <div
                        title={task.task}
                        style={{
                          maxWidth: '350px',
                          wordBreak: 'break-word',
                          overflowWrap: 'break-word',
                          lineHeight: '1.45'
                        }}
                      >
                        <span>{task.task}</span>
                        {subCount > 0 && (
                          <span
                            className="tm-subtask-count"
                            style={{
                              marginLeft: '6px',
                              fontWeight: 600,
                              color: '#d32f2f',
                              fontSize: '0.88em',
                              whiteSpace: 'nowrap'
                            }}
                            title={`${subCount} sub task${subCount > 1 ? 's' : ''}`}
                          >
                            ({subCount})
                          </span>
                        )}
                      </div>
                    );
                  })(),
                  project_name: task.project_name || '-',
                  assigned_developer: this.renderAssigneeAvatars(task),
                  task_deliver_date: this.formatDateForDisplay(task.task_deliver_date) || 'No due date',
                  timeline: (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%'
                      }}
                      onClick={(e) => e.stopPropagation()}
                      onMouseDown={(e) => e.stopPropagation()}
                    >
                      <TimelineSegmentedCell
                        value={task.timeline || ''}
                        onSave={(finalVal) => this.handleTimelineSegmentSave(task, finalVal)}
                      />
                    </div>
                  ),
                  priority: (
                    <div
                      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}
                      onClick={(e) => e.stopPropagation()}
                      onMouseDown={(e) => e.stopPropagation()}
                    >
                      <button
                        type="button"
                        className={`tm-table-priority-btn tm-priority-${String(task.priority || 'Medium').toLowerCase()}`}
                        onMouseDown={(e) => {
                          e.stopPropagation();
                          const target = e.currentTarget;
                          this.setState((prevState) => ({
                            priorityMenuAnchor: prevState.priorityMenuAnchor && prevState.priorityMenuTaskId === task.id ? null : target,
                            priorityMenuTaskId: prevState.priorityMenuAnchor && prevState.priorityMenuTaskId === task.id ? null : task.id,
                            statusMenuAnchor: null,
                            statusMenuTaskId: null
                          }));
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                        title="Click to change priority"
                      >
                        <span>{task.priority || 'Medium'}</span>
                        <ExpandMoreIcon className="tm-priority-arrow-icon" />
                      </button>
                    </div>
                  ),
                  status: (
                    <div
                      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}
                      onClick={(e) => e.stopPropagation()}
                      onMouseDown={(e) => e.stopPropagation()}
                    >
                      <button
                        type="button"
                        className={`tm-table-status-btn tm-status-btn-${String(task.status || 'Pending')
                          .toLowerCase()
                          .replace(/\s+/g, '')}`}
                        onMouseDown={(e) => {
                          e.stopPropagation();
                          const target = e.currentTarget;
                          this.setState((prevState) => ({
                            statusMenuAnchor: prevState.statusMenuAnchor && prevState.statusMenuTaskId === task.id ? null : target,
                            statusMenuTaskId: prevState.statusMenuAnchor && prevState.statusMenuTaskId === task.id ? null : task.id,
                            priorityMenuAnchor: null,
                            priorityMenuTaskId: null
                          }));
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                        title="Click to change status"
                      >
                        <span>{task.status === 'Pending' ? 'To Do' : (task.status || 'To Do')}</span>
                        <ExpandMoreIcon className="tm-status-arrow-icon" />
                      </button>
                    </div>
                  ),
                }))}
                tableCount={filteredTasks.length}
                isLoading={loading}
                colNameToShow={[
                  'select',
                  'project_task_id',
                  'priority',
                  'task',
                  'project_name',
                  'assigned_developer',
                  'task_deliver_date',
                  'timeline',
                  'status'
                ]}
                openPopUp={false}
                openPopUpUpdate={false}
                removeRow={(id) => this.handleDeleteTask(id)}
                actionBtns={['view', 'update', 'delete']}
                updateRoute={'/task/edit'}
                modelName={'Tasks'}
                shellClassName="holiday-table-shell"
                viewDetails={(row) => this.openTaskDrawer(row)}
                onRowClick={(row) => this.openTaskDrawer(row)}
                onPageChange={() => {}}
                onRowsPerPageChange={() => {}}
              />
            </div>
          )}
        </Card>

        {/* SLIDE-OUT TASK DETAIL DRAWER */}
        {activeDrawerTask && (
          <div className="tm-drawer-backdrop" onClick={this.closeTaskDrawer}>
            <div className="tm-drawer" onClick={(e) => e.stopPropagation()}>

              {/* Drawer Top Accent Bar (status-colored) */}
              <div className={`tm-drawer-accent-bar tm-drawer-accent-${String(activeDrawerTask.status || 'Pending').toLowerCase().replace(/\s+/g, '')}`} />

              {/* Drawer Header */}
              <div className="tm-drawer-header">
                <div className="tm-drawer-key-bar">
                  <div className="tm-drawer-task-id-badge">
                    <AssignmentIcon style={{ fontSize: 14 }} />
                    <span>{activeDrawerTask.project_task_id || `TASK-${activeDrawerTask.id}`}</span>
                  </div>
                  {activeDrawerTask.project_name && (
                    <div className="tm-drawer-project-badge">
                      {activeDrawerTask.project_name}
                    </div>
                  )}
                </div>

                <div className="tm-drawer-actions">
                  <button
                    type="button"
                    className="tm-btn-icon-danger"
                    onClick={() => this.handleDeleteTask(activeDrawerTask.id)}
                  >
                    <DeleteOutlineIcon style={{ fontSize: 15 }} />
                    Delete
                  </button>
                  <button
                    type="button"
                    className="tm-drawer-close-btn"
                    onClick={this.closeTaskDrawer}
                  >
                    <CloseIcon style={{ fontSize: 20 }} />
                  </button>
                </div>
              </div>

              {/* Drawer Body */}
              <div className="tm-drawer-body">

                {/* ===== MAIN COLUMN (left) ===== */}
                <div className="tm-drawer-main-col">

                  {/* Task Name Field */}
                  <div style={{ marginBottom: 14, marginTop: 8 }}>
                    <TextField
                      fullWidth
                      multiline
                      minRows={2}
                      maxRows={3}
                      variant="outlined"
                      label="Task Name"
                      placeholder="Enter task name"
                      error={Boolean(this.state.drawerTaskNameError)}
                      helperText={this.state.drawerTaskNameError || ''}
                      className={`holiday-form-input ${this.state.drawerTaskNameError ? 'input-error' : ''}`}
                      value={typeof activeDrawerTask.task === 'string' ? activeDrawerTask.task : ''}
                      onChange={(e) => {
                        const val = e.target.value;
                        const updated = { ...activeDrawerTask, task: val };
                        this.setState({
                          activeDrawerTask: updated,
                          drawerTaskNameError: val.trim() ? '' : 'Task name is required',
                          tasks: this.state.tasks.map((t) =>
                            t.id === activeDrawerTask.id ? updated : t
                          )
                        });
                      }}
                      onBlur={this.handleSaveDrawerTaskDetails}
                    />
                  </div>

                  {/* Description Field */}
                  <div style={{ marginBottom: 14 }}>
                    <WysiwygDescriptionEditor
                      label="Task Description"
                      placeholder="Add a detailed description..."
                      id="drawer_task_description"
                      name="description"
                      value={activeDrawerTask.description || ''}
                      onChange={(html) => {
                        const updated = { ...activeDrawerTask, description: html };
                        this.setState({
                          activeDrawerTask: updated,
                          tasks: this.state.tasks.map((t) =>
                            t.id === activeDrawerTask.id ? updated : t
                          )
                        });
                      }}
                      onBlur={this.handleSaveDrawerTaskDetails}
                      rows={6}
                    />
                  </div>

                  {/* Attachments Section */}
                  {(() => {
                    const filesList = Array.isArray(activeDrawerTask.files_parsed) && activeDrawerTask.files_parsed.length > 0
                      ? activeDrawerTask.files_parsed
                      : (Array.isArray(activeDrawerTask.files) ? activeDrawerTask.files : []);
                    return (
                      <div className="tm-drawer-section" style={{ marginBottom: 14 }}>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginBottom: 8
                          }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontWeight: 600, fontSize: 13, color: '#334155' }}>
                            <AttachFileIcon style={{ fontSize: 17, color: '#036dda' }} />
                            <span>ATTACHMENTS ({filesList.length})</span>
                          </div>
                          <input
                            type="file"
                            ref={this.drawerFileInputRef}
                            style={{ display: 'none' }}
                            multiple
                            accept="image/*,.jpg,.jpeg,.png,.webp,.gif,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv"
                            onChange={this.handleDrawerFileUpload}
                          />
                          <Button
                            size="small"
                            type="button"
                            variant="outlined"
                            disabled={this.state.drawerUploadingFile}
                            onClick={() => this.drawerFileInputRef.current && this.drawerFileInputRef.current.click()}
                            style={{
                              textTransform: 'none',
                              fontSize: 12,
                              fontWeight: 500,
                              color: '#036dda',
                              borderColor: '#bfdbfe',
                              backgroundColor: '#eff6ff',
                              padding: '2px 8px',
                              borderRadius: 6
                            }}
                          >
                            {this.state.drawerUploadingFile ? (
                              <CircularProgress size={14} style={{ marginRight: 4 }} />
                            ) : (
                              <CloudUploadIcon style={{ fontSize: 15, marginRight: 4 }} />
                            )}
                            Upload File
                          </Button>
                        </div>

                        {filesList.length === 0 ? (
                          <div style={{ fontSize: 12, color: '#94a3b8', fontStyle: 'italic', padding: '6px 0' }}>
                            No files or photos attached
                          </div>
                        ) : (
                          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                            {filesList.map((file, idx) => {
                              const fileName = file.name || file.original_name || (typeof file === 'string' ? file.split('/').pop() : `Attachment-${idx + 1}`);
                              const isImg = file.type?.startsWith('image/') || /\.(jpg|jpeg|png|gif|webp|svg)$/i.test(fileName);
                              const isPdf = file.type === 'application/pdf' || /\.pdf$/i.test(fileName);
                              const isWord = /\.docx?$/i.test(fileName);
                              const fileUrl = file.url;
                              return (
                                <div
                                  key={idx}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    padding: '7px 10px',
                                    backgroundColor: '#f8fafc',
                                    border: '1px solid #e2e8f0',
                                    borderRadius: 6,
                                    gap: 8
                                  }}
                                >
                                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0, flex: 1 }}>
                                    {isImg ? (
                                      fileUrl ? (
                                        <img
                                          src={fileUrl}
                                          alt={fileName}
                                          style={{ width: 28, height: 28, objectFit: 'cover', borderRadius: 4, border: '1px solid #cbd5e1' }}
                                        />
                                      ) : (
                                        <ImageIcon style={{ fontSize: 20, color: '#3b82f6', flexShrink: 0 }} />
                                      )
                                    ) : isPdf ? (
                                      <PictureAsPdfIcon style={{ fontSize: 20, color: '#ef4444', flexShrink: 0 }} />
                                    ) : isWord ? (
                                      <InsertDriveFileIcon style={{ fontSize: 20, color: '#2563eb', flexShrink: 0 }} />
                                    ) : (
                                      <InsertDriveFileIcon style={{ fontSize: 20, color: '#64748b', flexShrink: 0 }} />
                                    )}
                                    <div style={{ minWidth: 0, flex: 1 }}>
                                      <div
                                        style={{
                                          fontSize: 12,
                                          fontWeight: 500,
                                          color: '#1e293b',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          whiteSpace: 'nowrap'
                                        }}
                                        title={fileName}
                                      >
                                        {fileName}
                                      </div>
                                      {file.size && (
                                        <div style={{ fontSize: 10, color: '#94a3b8' }}>
                                          {(file.size / 1024).toFixed(1)} KB
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div style={{ display: 'flex', alignItems: 'center', gap: 2, flexShrink: 0 }}>
                                    {fileUrl && (
                                      <Tooltip title="View / Preview" arrow>
                                        <IconButton
                                          size="small"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            this.handleViewFile(file);
                                          }}
                                          style={{ color: '#036dda', padding: 4 }}
                                        >
                                          <VisibilityIcon style={{ fontSize: 17 }} />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                    <Tooltip title="Download" arrow>
                                      <IconButton
                                        size="small"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          this.handleDownloadFile(file);
                                        }}
                                        style={{ color: '#10b981', padding: 4 }}
                                      >
                                        <GetAppIcon style={{ fontSize: 17 }} />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Delete" arrow>
                                      <IconButton
                                        size="small"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          this.handleDrawerFileDelete(idx);
                                        }}
                                        style={{ color: '#94a3b8', padding: 4 }}
                                      >
                                        <CloseIcon style={{ fontSize: 16 }} />
                                      </IconButton>
                                    </Tooltip>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  })()}

                  {/* Subtasks Checklist */}
                  <div className="tm-drawer-section" style={{ marginBottom: 14 }}>
                    {/* Add Subtask Inline - at the top */}
                    <div className="tm-subtask-inline-add" style={{ marginBottom: (activeDrawerTask.sub_tasks_parsed || []).length > 0 ? 14 : 0 }}>
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Add Subtask"
                        placeholder="Add a subtask..."
                        className="holiday-form-input"
                        value={drawerNewSubtaskTitle}
                        onChange={(e) => this.setState({ drawerNewSubtaskTitle: e.target.value })}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            this.handleAddSubtaskInline();
                          }
                        }}
                      />
                      <Button
                        type="button"
                        variant="contained"
                        onClick={this.handleAddSubtaskInline}
                        style={{
                          height: 40,
                          minWidth: 72,
                          textTransform: 'none',
                          fontWeight: 400,
                          fontSize: 14,
                          borderRadius: 8,
                          backgroundColor: '#036dda',
                          color: '#ffffff',
                          boxShadow: 'none',
                          whiteSpace: 'nowrap',
                          flexShrink: 0
                        }}
                      >
                        Add
                      </Button>
                    </div>

                    {(activeDrawerTask.sub_tasks_parsed || []).length > 0 && (
                      <div className="tm-section-label" style={{ justifyContent: 'flex-end', marginBottom: 6, marginTop: 12 }}>
                        <span className="tm-subtask-progress-label">
                          {(activeDrawerTask.sub_tasks_parsed || []).filter(st => st.status === 'Done').length}
                          &nbsp;/&nbsp;
                          {(activeDrawerTask.sub_tasks_parsed || []).length} done
                        </span>
                      </div>
                    )}

                    {/* Progress Bar */}
                    {(activeDrawerTask.sub_tasks_parsed || []).length > 0 && (
                      <div className="tm-progress-track">
                        <div
                          className="tm-progress-bar-fill"
                          style={{
                            width: `${
                              ((activeDrawerTask.sub_tasks_parsed || []).filter(st => st.status === 'Done').length /
                                (activeDrawerTask.sub_tasks_parsed || []).length) * 100
                            }%`
                          }}
                        />
                      </div>
                    )}

                    {/* Subtasks List - shown below */}
                    <div className="tm-subtasks-list">
                      {(activeDrawerTask.sub_tasks_parsed || []).map((subTask, idx) => {
                        const isEditing = drawerEditingSubtaskIdx === idx;
                        return (
                          <div
                            key={idx}
                            className={`tm-subtask-item ${subTask.status === 'Done' ? 'is-done' : ''}`}
                          >
                            {/* Checkbox toggle */}
                            <div
                              className="tm-subtask-check"
                              onClick={() => {
                                if (!isEditing) this.handleSubtaskToggle(subTask);
                              }}
                            >
                              {subTask.status === 'Done' ? (
                                <CheckCircleOutlineIcon style={{ color: '#10b981', fontSize: 18 }} />
                              ) : (
                                <RadioButtonUncheckedIcon style={{ color: '#94a3b8', fontSize: 18 }} />
                              )}
                            </div>

                            {/* Name or inline edit input */}
                            {isEditing ? (
                              <input
                                className="tm-subtask-edit-input"
                                autoFocus
                                value={drawerEditingSubtaskName}
                                onChange={(e) => this.setState({ drawerEditingSubtaskName: e.target.value })}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter') this.handleSaveSubtaskEdit();
                                  if (e.key === 'Escape') this.setState({ drawerEditingSubtaskIdx: null, drawerEditingSubtaskName: '' });
                                }}
                                onBlur={this.handleSaveSubtaskEdit}
                              />
                            ) : (
                              <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 6, overflow: 'hidden' }}>
                                <span
                                  className="tm-subtask-id-badge"
                                  style={{
                                    fontSize: '11px',
                                    fontWeight: 700,
                                    color: '#036dda',
                                    backgroundColor: 'rgba(3, 109, 218, 0.08)',
                                    padding: '1px 6px',
                                    borderRadius: 3,
                                    border: '1px solid rgba(3, 109, 218, 0.2)',
                                    flexShrink: 0,
                                    letterSpacing: '0.2px'
                                  }}
                                  title={`Parent: ${subTask.parent_id || activeDrawerTask.project_task_id || activeDrawerTask.id}`}
                                >
                                  {subTask.child_id || subTask.sub_task_id || `${activeDrawerTask.project_task_id || activeDrawerTask.id}.${idx + 1}`}
                                </span>
                                <span
                                  className={`tm-subtask-text ${subTask.status === 'Done' ? 'is-done' : ''}`}
                                  style={{ flex: 1 }}
                                >
                                  {subTask.name}
                                </span>
                              </div>
                            )}

                            {/* Edit + Delete action buttons (HRMS standard icons) */}
                            {!isEditing && (
                              <div className="tm-subtask-actions">
                                <Tooltip title="Edit Subtask">
                                  <IconButton
                                    type="button"
                                    size="small"
                                    className="common-action-icon"
                                    onClick={(e) => { e.stopPropagation(); this.handleStartEditSubtask(idx, subTask.name); }}
                                    style={{ padding: 4 }}
                                  >
                                    <FontAwesomeIconComponent
                                      classes="fa fa-edit"
                                      colorName="primary"
                                      fontSize="small"
                                    />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Delete Subtask">
                                  <IconButton
                                    type="button"
                                    size="small"
                                    className="common-action-icon"
                                    onClick={(e) => { e.stopPropagation(); this.handleDeleteSubtask(idx); }}
                                    style={{ padding: 4 }}
                                  >
                                    <FontAwesomeIconComponent
                                      classes="fa fa-trash"
                                      colorName="primary"
                                      fontSize="small"
                                    />
                                  </IconButton>
                                </Tooltip>
                              </div>
                            )}
                            {isEditing && (
                              <button
                                type="button"
                                className="tm-subtask-action-btn tm-subtask-save-btn"
                                title="Save"
                                onClick={this.handleSaveSubtaskEdit}
                              >
                                <CheckIcon style={{ fontSize: 14 }} />
                              </button>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* Activity & History Collapsible Dropdown */}
                  <div className="tm-drawer-section" style={{ marginTop: 16 }}>
                    <div
                      className="tm-activity-collapse-header"
                      onClick={() => this.setState({ drawerActivityOpen: !this.state.drawerActivityOpen })}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        cursor: 'pointer',
                        padding: '10px 14px',
                        backgroundColor: 'var(--tm-surface-subtle, #f8fafc)',
                        borderRadius: 8,
                        border: '1px solid var(--tm-border, #e2e8f0)',
                        userSelect: 'none',
                        transition: 'all 0.2s ease',
                        marginBottom: this.state.drawerActivityOpen ? 12 : 0
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ fontWeight: 600, fontSize: 13, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                          Activity & History
                        </span>
                      </div>
                      <ExpandMoreIcon
                        style={{
                          fontSize: 20,
                          color: '#64748b',
                          transition: 'transform 0.25s ease',
                          transform: this.state.drawerActivityOpen ? 'rotate(180deg)' : 'rotate(0deg)'
                        }}
                      />
                    </div>

                    {this.state.drawerActivityOpen && (
                      <div>
                        {drawerLoadingActivity ? (
                          <div className="tm-activity-loading">
                            <CircularProgress size={22} style={{ color: 'var(--tm-primary)' }} />
                            <span>Loading activity...</span>
                          </div>
                        ) : drawerActivity.length === 0 ? (
                          <div className="tm-activity-empty">
                            <span>No activity recorded yet for this task.</span>
                          </div>
                        ) : (
                          <div className="tm-activity-timeline">
                            {drawerActivity.map((log, idx) => {
                              const msg = log.description || log.message || '';
                              const time = log.timestamp || log.created_at || '';
                              // Pick color accent based on content keywords
                              let accentClass = 'tm-activity-entry';
                              if (/creat/i.test(msg)) accentClass += ' is-create';
                              else if (/status/i.test(msg)) accentClass += ' is-status';
                              else if (/priority/i.test(msg)) accentClass += ' is-priority';
                              else if (/delet/i.test(msg)) accentClass += ' is-delete';
                              else if (/assign/i.test(msg)) accentClass += ' is-assign';
                              return (
                                <div key={idx} className={accentClass}>
                                  <div className="tm-activity-dot" />
                                  <div className="tm-activity-content">
                                    <div className="tm-activity-message">{msg}</div>
                                    {time && <div className="tm-activity-time">{time}</div>}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {/* ===== DETAILS SIDEBAR (right) ===== */}
                <div className="tm-drawer-side-col">

                  {/* STATUS */}
                  <div className="tm-side-detail-block">
                    <span className="tm-side-block-label">Status</span>
                    <button
                      type="button"
                      className={`tm-table-status-btn tm-status-btn-${String(activeDrawerTask.status || 'Pending')
                        .toLowerCase()
                        .replace(/\s+/g, '')}`}
                      style={{ fontSize: 13, width: 'fit-content', whiteSpace: 'nowrap' }}
                      onClick={(e) => {
                        e.stopPropagation();
                        this.setState({
                          statusMenuAnchor: e.currentTarget,
                          statusMenuTaskId: activeDrawerTask.id
                        });
                      }}
                      title="Click to change status"
                    >
                      <span className="tm-status-btn-dot" />
                      <span>{activeDrawerTask.status === 'Pending' ? 'To Do' : (activeDrawerTask.status || 'To Do')}</span>
                      <ExpandMoreIcon className="tm-status-arrow-icon" style={{ fontSize: 16 }} />
                    </button>
                  </div>

                  <div className="tm-side-divider" />

                  {/* ASSIGNEE (only profile avatars) */}
                  <div className="tm-side-detail-block">
                    <span className="tm-side-block-label">Assignee</span>
                    <div className="tm-assignee-profiles-row">
                      {this.renderAssigneeAvatars(activeDrawerTask)}
                    </div>
                  </div>

                  <div className="tm-side-divider" />

                  {/* PROJECT */}
                  <div className="tm-side-detail-block">
                    <span className="tm-side-block-label">Project</span>
                    <div className="tm-side-project-badge">
                      <AssignmentIcon className="tm-side-project-icon" style={{ fontSize: 15 }} />
                      <span>{activeDrawerTask.project_name || '—'}</span>
                    </div>
                  </div>

                  <div className="tm-side-divider" />

                  {/* PRIORITY */}
                  <div className="tm-side-detail-block">
                    <span className="tm-side-block-label">Priority</span>
                    <button
                      type="button"
                      className={`tm-table-priority-btn tm-priority-${String(activeDrawerTask.priority || 'Medium').toLowerCase()}`}
                      style={{ fontSize: 13, width: 'fit-content', whiteSpace: 'nowrap' }}
                      onMouseDown={(e) => {
                        e.stopPropagation();
                        const target = e.currentTarget;
                        this.setState((prevState) => ({
                          priorityMenuAnchor: prevState.priorityMenuAnchor && prevState.priorityMenuTaskId === activeDrawerTask.id ? null : target,
                          priorityMenuTaskId: prevState.priorityMenuAnchor && prevState.priorityMenuTaskId === activeDrawerTask.id ? null : activeDrawerTask.id
                        }));
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      title="Click to change priority"
                    >
                      <span>{activeDrawerTask.priority || 'Medium'}</span>
                      <ExpandMoreIcon className="tm-priority-arrow-icon" style={{ fontSize: 16 }} />
                    </button>
                  </div>

                  {/* TASK DATE & TIME */}
                  <div className="tm-side-divider" />
                  <div className="tm-side-detail-block">
                    <span className="tm-side-block-label">Task Date &amp; Time</span>
                    <div className="tm-side-date-row">
                      <CalendarTodayIcon className="tm-side-date-icon" style={{ fontSize: 15 }} />
                      <span className={`tm-side-value ${!this.formatDateForDisplay(activeDrawerTask.task_date_time) ? 'is-empty' : ''}`}>
                        {this.formatDateForDisplay(activeDrawerTask.task_date_time) || 'Not set'}
                      </span>
                    </div>
                  </div>

                  {/* DELIVER DUE DATE */}
                  <div className="tm-side-divider" />
                  <div className="tm-side-detail-block">
                    <span className="tm-side-block-label">Deliver Due Date</span>
                    <div className="tm-side-date-row">
                      <CalendarTodayIcon className="tm-side-date-icon" style={{ fontSize: 15 }} />
                      <span className={`tm-side-value ${!this.formatDateForDisplay(activeDrawerTask.task_deliver_date) ? 'is-empty' : ''}`}>
                        {this.formatDateForDisplay(activeDrawerTask.task_deliver_date) || 'No due date'}
                      </span>
                    </div>
                  </div>

                  {/* TIMELINE */}
                  <div className="tm-side-divider" />
                  <div className="tm-side-detail-block">
                    <span className="tm-side-block-label">Timeline</span>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 4 }}>
                      <TimelineSegmentedCell
                        value={activeDrawerTask.timeline || ''}
                        onSave={(finalVal) => this.handleTimelineSegmentSave(activeDrawerTask, finalVal)}
                      />
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        )}

        {/* CREATE TASK MODAL */}
        <Dialog
          open={isCreateModalOpen}
          onClose={this.closeCreateModal}
          maxWidth="md"
          fullWidth
          PaperProps={{ className: 'tm-modal-paper' }}
        >
          <DialogTitle style={{ borderBottom: '1px solid var(--tm-border)', padding: '16px 24px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span style={{ fontWeight: 700, fontSize: 18 }}>Create Task</span>
              <CloseIcon style={{ cursor: 'pointer' }} onClick={this.closeCreateModal} />
            </div>
          </DialogTitle>

          <form onSubmit={this.handleCreateTaskSubmit}>
            <DialogContent style={{ padding: '20px 24px' }}>
              <div className="tm-form-grid">
                {/* Project */}
                <div className="tm-form-field">
                  <label>Project *</label>
                  <select
                    className="tm-select-custom"
                    style={{ width: '100%' }}
                    value={createTaskForm.project_name}
                    onChange={(e) => this.handleCreateFormChange('project_name', e.target.value)}
                    required
                  >
                    {projects.filter((p) => Number(p.status) === 1).length === 0 ? (
                      <option value="" disabled>No active project available</option>
                    ) : (
                      <>
                        <option value="" disabled>Select Project</option>
                        {projects.filter((p) => Number(p.status) === 1).map((p) => (
                          <option key={p.id || p.project_name} value={p.project_name}>
                            {p.project_name}
                          </option>
                        ))}
                      </>
                    )}
                  </select>
                </div>

                {/* Assignee / Developer */}
                <div className="tm-form-field">
                  <label>Assignee (Developer) *</label>
                  <select
                    className="tm-select-custom"
                    style={{ width: '100%' }}
                    value={createTaskForm.developer_user_id}
                    onChange={(e) => this.handleCreateFormChange('developer_user_id', e.target.value)}
                    required
                  >
                    <option value="">Select Assignee</option>
                    {this.getProjectAssignees(createTaskForm.project_name).map((u) => (
                      <option key={u.id} value={u.id}>
                        {u.firstName} {u.lastName || ''}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Task Title */}
                <div className="tm-form-field tm-form-full">
                  <label>Task Summary / Title *</label>
                  <input
                    type="text"
                    className="tm-input"
                    placeholder="e.g. Implement user authentication module"
                    value={createTaskForm.task}
                    onChange={(e) => this.handleCreateFormChange('task', e.target.value)}
                    required
                  />
                </div>

                {/* Status */}
                <div className="tm-form-field">
                  <label>Status</label>
                  <select
                    className="tm-select-custom"
                    style={{ width: '100%' }}
                    value={createTaskForm.status}
                    onChange={(e) => this.handleCreateFormChange('status', e.target.value)}
                  >
                    <option value="Backlog">Backlog</option>
                    <option value="Pending">To Do</option>
                    <option value="In Progress">In Progress</option>
                    <option value="Testing">Testing</option>
                    <option value="Done">Done</option>
                  </select>
                </div>

                {/* Priority */}
                <div className="tm-form-field">
                  <label>Priority</label>
                  <select
                    className="tm-select-custom"
                    style={{ width: '100%' }}
                    value={createTaskForm.priority}
                    onChange={(e) => this.handleCreateFormChange('priority', e.target.value)}
                  >
                    <option value="Urgent">Urgent</option>
                    <option value="High">High</option>
                    <option value="Medium">Medium</option>
                    <option value="Low">Low</option>
                  </select>
                </div>

                {/* Task Date & Time */}
                <div className="tm-form-field">
                  <label>Task Date & Time (Start) *</label>
                  <input
                    type="datetime-local"
                    className="tm-input"
                    value={createTaskForm.task_date_time.replace(' ', 'T').slice(0, 16)}
                    onChange={(e) =>
                      this.handleCreateFormChange(
                        'task_date_time',
                        e.target.value ? e.target.value.replace('T', ' ') + ':00' : ''
                      )
                    }
                    required
                  />
                </div>

                {/* Deliver Date */}
                <div className="tm-form-field">
                  <label>Deliver Due Date</label>
                  <input
                    type="datetime-local"
                    className="tm-input"
                    value={createTaskForm.task_deliver_date.replace(' ', 'T').slice(0, 16)}
                    onChange={(e) =>
                      this.handleCreateFormChange(
                        'task_deliver_date',
                        e.target.value ? e.target.value.replace('T', ' ') + ':00' : ''
                      )
                    }
                  />
                </div>

                {/* Description (Material-UI Outlined TextField with Wysiwyg Rich Formatting) */}
                <div className="tm-form-field tm-form-full">
                  <WysiwygDescriptionEditor
                    label="Description"
                    placeholder="Provide details and acceptance criteria..."
                    id="create_task_modal_description"
                    name="description"
                    value={createTaskForm.description || ''}
                    onChange={(html) => this.handleCreateFormChange('description', html)}
                    rows={4}
                  />
                </div>

                {/* Subtasks Builder */}
                <div className="tm-form-field tm-form-full">
                  <label>Subtasks</label>
                  <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                    <input
                      type="text"
                      className="tm-input"
                      placeholder="Add subtask title..."
                      value={newSubtaskInput}
                      onChange={(e) => this.setState({ newSubtaskInput: e.target.value })}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          this.handleAddSubtaskToModal();
                        }
                      }}
                    />
                    <button
                      type="button"
                      className="tm-btn-secondary"
                      onClick={this.handleAddSubtaskToModal}
                    >
                      Add
                    </button>
                  </div>

                  {createTaskForm.subTasks.map((st, idx) => (
                    <div
                      key={idx}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '6px 12px',
                        background: 'var(--tm-surface-hover)',
                        borderRadius: 6,
                        marginBottom: 6
                      }}
                    >
                      <span>{st.name}</span>
                      <IconButton
                        size="small"
                        className="common-action-icon"
                        onClick={() => this.handleRemoveSubtaskFromModal(idx)}
                        style={{ padding: 4 }}
                      >
                        <FontAwesomeIconComponent
                          classes="fa fa-trash"
                          colorName="primary"
                          fontSize="small"
                        />
                      </IconButton>
                    </div>
                  ))}
                </div>
              </div>
            </DialogContent>

            <DialogActions style={{ padding: '16px 24px', borderTop: '1px solid var(--tm-border)' }}>
              <button type="button" className="tm-btn-secondary" onClick={this.closeCreateModal}>
                Cancel
              </button>
              <button
                type="submit"
                className="tm-btn-primary"
                disabled={createTaskSubmitting}
              >
                {createTaskSubmitting ? 'Creating in DB...' : 'Create Task'}
              </button>
            </DialogActions>
          </form>
        </Dialog>

        {/* ADD PROJECT MODAL */}
        <Dialog
          open={isAddProjectModalOpen}
          onClose={this.closeAddProjectModal}
          maxWidth="md"
          fullWidth
          className="tm-project-dialog"
          PaperProps={{ className: 'tm-modal-paper' }}
        >
          <DialogTitle
            disableTypography
            style={{
              borderBottom: '1px solid var(--tm-border)',
              padding: '16px 24px',
              backgroundColor: '#ffffff'
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span className="tm-project-dialog-title-text" style={{ fontWeight: 700, fontSize: 20, color: '#036dda' }}>
                Add New Project
              </span>
              <IconButton size="small" onClick={this.closeAddProjectModal} style={{ color: '#64748b' }}>
                <CloseIcon />
              </IconButton>
            </div>
          </DialogTitle>

          <form className="common-form-fields" onSubmit={this.handleAddProjectSubmit}>
            <DialogContent style={{ padding: '24px 24px' }}>
              <Grid container spacing={3}>
                {/* Project Name * */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Project Name *"
                    placeholder="Enter project name..."
                    value={addProjectForm.project_name}
                    onChange={(e) => this.handleAddProjectFormChange('project_name', e.target.value)}
                    required
                  />
                </Grid>

                {/* Description (Material-UI Outlined TextField with Wysiwyg Rich Formatting) */}
                <Grid item xs={12}>
                  <WysiwygDescriptionEditor
                    label="Description"
                    placeholder="Enter project description..."
                    id="add_project_modal_description"
                    name="description"
                    value={addProjectForm.description || ''}
                    onChange={(html) => this.handleAddProjectFormChange('description', html)}
                    rows={4}
                  />
                </Grid>

                {/* Start Date */}
                <Grid item xs={12} sm={6}>
                  <DdMmYyyyDateField
                    id="project_start_date"
                    name="project_start_date"
                    label="Start-date"
                    size="medium"
                    value={addProjectForm.start_date}
                    onChange={(e) => this.handleAddProjectFormChange('start_date', e.target.value)}
                    max={addProjectForm.target_date || undefined}
                  />
                </Grid>

                {/* End Date */}
                <Grid item xs={12} sm={6}>
                  <DdMmYyyyDateField
                    id="project_target_date"
                    name="project_target_date"
                    label="End-date"
                    size="medium"
                    value={addProjectForm.target_date}
                    onChange={(e) => this.handleAddProjectFormChange('target_date', e.target.value)}
                    min={addProjectForm.start_date || undefined}
                  />
                </Grid>

                {/* Select User (Active Users Only) */}
                <Grid item xs={12}>
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel id="project-users-outlined-label">Select User (Active Users Only)</InputLabel>
                    <Select
                      labelId="project-users-outlined-label"
                      id="project-users-outlined-select"
                      multiple
                      variant="outlined"
                      label="Select User (Active Users Only)"
                      value={addProjectForm.member_ids || []}
                      onChange={(e) => {
                        this.setState({
                          addProjectForm: {
                            ...this.state.addProjectForm,
                            member_ids: typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value
                          }
                        });
                      }}
                      renderValue={(selected) => {
                        if (!selected || selected.length === 0) {
                          return <span style={{ color: '#94a3b8' }}>Choose active users for this project...</span>;
                        }
                        return (
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                            {selected.map((uid) => {
                              const userObj = (allUsers || []).find((u) => Number(u.id) === Number(uid));
                              const name = userObj
                                ? (userObj.firstName ? `${userObj.firstName} ${userObj.lastName || ''}`.trim() : userObj.name)
                                : `User #${uid}`;
                              return (
                                <span
                                  key={uid}
                                  style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 5,
                                    padding: '2px 8px',
                                    background: '#e0f2fe',
                                    color: '#0369a1',
                                    borderRadius: 14,
                                    fontSize: 12,
                                    fontWeight: 600
                                  }}
                                >
                                  <Avatar style={{ width: 18, height: 18, fontSize: 9 }}>
                                    {this.getInitials(name)}
                                  </Avatar>
                                  <span>{name}</span>
                                </span>
                              );
                            })}
                          </div>
                        );
                      }}
                      MenuProps={{
                        disableScrollLock: true,
                        PaperProps: {
                          style: {
                            maxHeight: 280,
                            width: 320
                          }
                        }
                      }}
                    >
                      {activeUsers.map((user) => {
                        const displayName = user.firstName ? `${user.firstName} ${user.lastName || ''}`.trim() : user.name;
                        const isChecked = (addProjectForm.member_ids || []).includes(user.id);
                        return (
                          <MenuItem key={user.id} value={user.id}>
                            <Checkbox checked={isChecked} color="primary" size="small" style={{ padding: 4, marginRight: 6 }} />
                            <Avatar
                              src={user.photo || ''}
                              style={{ width: 24, height: 24, marginRight: 8, fontSize: 11 }}
                            >
                              {this.getInitials(displayName)}
                            </Avatar>
                            <ListItemText primary={displayName} />
                          </MenuItem>
                        );
                      })}
                      {activeUsers.length === 0 && (
                        <MenuItem disabled>No active users found</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </Grid>

                {/* Document Upload (Optional - all file types supported) */}
                <Grid item xs={12}>
                  <div className="tm-outlined-section">
                    <span className="tm-outlined-legend">
                      Document Upload (Optional - JPG, PNG, PDF, Word, DOC, spreadsheets, etc.)
                    </span>
                    <input
                      type="file"
                      id="tm-add-project-files"
                      multiple
                      accept=".jpg,.jpeg,.png,.webp,.gif,.pdf,.doc,.docx,.xls,.xlsx,.txt,.csv"
                      style={{ display: 'none' }}
                      onChange={this.handleProjectFileSelect}
                    />
                    <label htmlFor="tm-add-project-files" className="tm-file-upload-zone" style={{ margin: 0 }}>
                      <CloudUploadIcon style={{ fontSize: 32, color: '#036dda' }} />
                      <span style={{ fontWeight: 600, fontSize: 13, color: '#036dda' }}>
                        Click to upload documents or images
                      </span>
                      <span style={{ fontSize: 11, color: '#64748b' }}>
                        Supports all types: JPG, PNG, PDF, DOC, DOCX, Word, etc.
                      </span>
                    </label>

                    {/* Attached Files List */}
                    {addProjectFiles && addProjectFiles.length > 0 && (
                      <div style={{ marginTop: 8 }}>
                        {addProjectFiles.map((file, idx) => {
                          const isImg = file.type ? file.type.startsWith('image/') : false;
                          const isPdf = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
                          return (
                            <div key={idx} className="tm-selected-file-item">
                              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                {isImg ? (
                                  <ImageIcon style={{ color: '#0284c7', fontSize: 20 }} />
                                ) : isPdf ? (
                                  <PictureAsPdfIcon style={{ color: '#ef4444', fontSize: 20 }} />
                                ) : (
                                  <InsertDriveFileIcon style={{ color: '#64748b', fontSize: 20 }} />
                                )}
                                <span style={{ fontWeight: 500, color: 'var(--tm-text)' }}>{file.name}</span>
                                <span style={{ fontSize: 11, color: '#64748b' }}>
                                  ({(file.size / 1024).toFixed(1)} KB)
                                </span>
                              </div>
                              <IconButton size="small" onClick={() => this.handleRemoveProjectFile(idx)}>
                                <CloseIcon style={{ color: '#ef4444', fontSize: 18 }} />
                              </IconButton>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </Grid>

                {/* Milestone Text Area */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    rowsMin={4}
                    variant="outlined"
                    id="add_project_milestone"
                    name="milestone"
                    label="Milestone"
                    placeholder="Enter milestone / project description..."
                    value={newMilestoneInput}
                    onChange={(e) => this.setState({ newMilestoneInput: e.target.value })}
                    inputProps={{
                      style: {
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none',
                        overflowY: 'hidden',
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </DialogContent>

            <DialogActions style={{ padding: '16px 24px', borderTop: '1px solid var(--tm-border)', justifyContent: 'flex-start' }}>
              <Button
                type="submit"
                variant="contained"
                disabled={addProjectSubmitting}
                style={{
                  backgroundColor: '#036dda',
                  color: '#ffffff',
                  textTransform: 'none',
                  fontWeight: 600,
                  padding: '8px 28px',
                  borderRadius: 4,
                  boxShadow: 'none'
                }}
              >
                {addProjectSubmitting ? 'Saving...' : 'Save'}
              </Button>
              <Button
                type="button"
                onClick={this.closeAddProjectModal}
                style={{
                  backgroundColor: '#f1f5f9',
                  color: '#475569',
                  textTransform: 'none',
                  fontWeight: 600,
                  padding: '8px 24px',
                  borderRadius: 4,
                  marginLeft: 12
                }}
              >
                Cancel
              </Button>
            </DialogActions>
          </form>
        </Dialog>

        {/* Premium Interactive Priority Menu */}
        <Menu
          anchorEl={this.state.priorityMenuAnchor}
          open={Boolean(this.state.priorityMenuAnchor)}
          onClose={() => this.setState({ priorityMenuAnchor: null, priorityMenuTaskId: null })}
          disableScrollLock
          autoFocus={false}
          MenuListProps={{ autoFocusItem: false }}
          getContentAnchorEl={null}
          style={{ zIndex: 2500 }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          transformOrigin={{ vertical: 'top', horizontal: 'center' }}
          elevation={4}
          PaperProps={{
            className: 'tm-priority-menu-paper',
            style: {
              borderRadius: 10,
              minWidth: 140,
              padding: '6px 0',
              boxShadow: '0 10px 25px rgba(0, 0, 0, 0.12)',
              marginTop: 4
            }
          }}
        >
          {[
            { label: 'Low', value: 'low' },
            { label: 'Medium', value: 'medium' },
            { label: 'High', value: 'high' },
            { label: 'Urgent', value: 'urgent' }
          ].map((opt) => {
            const currentTask = (this.state.tasks || []).find(
              (t) => Number(t.id) === Number(this.state.priorityMenuTaskId)
            ) || (this.state.activeDrawerTask && Number(this.state.activeDrawerTask.id) === Number(this.state.priorityMenuTaskId) ? this.state.activeDrawerTask : null);
            const isSelected =
              currentTask &&
              String(currentTask.priority || 'Medium').toLowerCase() === opt.label.toLowerCase();

            return (
              <MenuItem
                key={opt.label}
                selected={Boolean(isSelected)}
                className={`tm-priority-menu-item tm-priority-menu-item-${opt.value}${isSelected ? ' is-selected' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  const taskId = this.state.priorityMenuTaskId;
                  this.setState({ priorityMenuAnchor: null, priorityMenuTaskId: null }, () => {
                    if (taskId) {
                      this.handlePriorityChange(taskId, opt.label);
                    }
                  });
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '9px 16px',
                  fontSize: '0.85rem',
                  fontWeight: isSelected ? 700 : 500,
                  cursor: 'pointer'
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span
                    className={`tm-priority-menu-dot tm-priority-dot-${opt.value}`}
                    style={{
                      width: 9,
                      height: 9,
                      borderRadius: '50%',
                      display: 'inline-block',
                      flexShrink: 0,
                      backgroundColor: isSelected ? '#ffffff' : undefined
                    }}
                  />
                  <span
                    className={`tm-priority-menu-label tm-priority-label-${opt.value}`}
                    style={{
                      fontWeight: 700,
                      fontSize: 13,
                      color: isSelected ? '#ffffff' : undefined
                    }}
                  >
                    {opt.label}
                  </span>
                </div>
                {isSelected && <CheckIcon className="tm-priority-check-icon" style={{ fontSize: 16 }} />}
              </MenuItem>
            );
          })}
        </Menu>

        {/* Premium Interactive Status Menu */}
        <Menu
          anchorEl={this.state.statusMenuAnchor}
          open={Boolean(this.state.statusMenuAnchor)}
          onClose={() => this.setState({ statusMenuAnchor: null, statusMenuTaskId: null })}
          disableScrollLock
          autoFocus={false}
          MenuListProps={{ autoFocusItem: false }}
          getContentAnchorEl={null}
          style={{ zIndex: 2500 }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          transformOrigin={{ vertical: 'top', horizontal: 'center' }}
          elevation={4}
          PaperProps={{
            className: 'tm-status-menu-paper',
            style: {
              borderRadius: 10,
              minWidth: 150,
              padding: '6px 0',
              boxShadow: '0 10px 25px rgba(0, 0, 0, 0.12)',
              marginTop: 4
            }
          }}
        >
          {[
            { id: 'Backlog', label: 'Backlog', value: 'backlog' },
            { id: 'Pending', label: 'To Do', value: 'todo' },
            { id: 'In Progress', label: 'In Progress', value: 'inprogress' },
            { id: 'In Discuss', label: 'In Discuss', value: 'indiscuss' },
            { id: 'Testing', label: 'Testing', value: 'testing' },
            { id: 'Done', label: 'Done', value: 'done' }
          ].map((opt) => {
            const currentTask = (this.state.tasks || []).find(
              (t) => Number(t.id) === Number(this.state.statusMenuTaskId)
            ) || (this.state.activeDrawerTask && Number(this.state.activeDrawerTask.id) === Number(this.state.statusMenuTaskId) ? this.state.activeDrawerTask : null);
            const isSelected =
              currentTask &&
              (currentTask.status === opt.id ||
                (opt.id === 'Pending' && currentTask.status === 'To Do') ||
                (opt.id === 'Testing' && String(currentTask.status).toLowerCase().includes('test')));

            return (
              <MenuItem
                key={opt.id}
                selected={Boolean(isSelected)}
                className={`tm-status-menu-item tm-status-menu-item-${opt.value}${isSelected ? ' is-selected' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  const taskId = this.state.statusMenuTaskId;
                  this.setState({ statusMenuAnchor: null, statusMenuTaskId: null }, () => {
                    if (taskId) {
                      this.handleTableStatusChange(taskId, opt.id);
                    }
                  });
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '9px 16px',
                  fontSize: '0.85rem',
                  fontWeight: isSelected ? 700 : 500,
                  cursor: 'pointer'
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span
                    className={`tm-status-menu-dot tm-status-dot-${opt.value}`}
                    style={{
                      width: 9,
                      height: 9,
                      borderRadius: '50%',
                      display: 'inline-block',
                      flexShrink: 0,
                      backgroundColor: isSelected ? '#ffffff' : undefined
                    }}
                  />
                  <span
                    className={`tm-status-menu-label tm-status-label-${opt.value}`}
                    style={{
                      fontWeight: 700,
                      fontSize: 13,
                      color: isSelected ? '#ffffff' : undefined
                    }}
                  >
                    {opt.label}
                  </span>
                </div>
                {isSelected && <CheckIcon className="tm-status-check-icon" style={{ fontSize: 16 }} />}
              </MenuItem>
            );
          })}
        </Menu>
        <FilePreviewDialog
          file={this.state.previewFile}
          open={Boolean(this.state.previewFile)}
          onClose={this.handleClosePreview}
        />
      </div>
    );

    return (
      <div>
        <AuthCheckComponent authToken={this.props.authToken} />
        <Header
          {...this.props}
          authUser={this.props.authUser}
          setAutUser={this.props.setAutUser}
          component={pageContent}
        />
        <Footer />
      </div>
    );
  }
}

export default TaskManagement;
